import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {FirebaseService} from './firebase.service';
import {MatBottomSheet, MatSnackBar} from '@angular/material';
import 'rxjs/add/observable/defer';
import {BizhoursService, BizYear} from './bizhours.service';
import {AdminService, Module, PhoneObj} from './admin.service';
import {AngularFirestore} from '@angular/fire/firestore';
import * as _ from 'lodash';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AngularFireAuth} from '@angular/fire/auth';
import {Languages} from './constants';
import {AngularFireDatabase} from '@angular/fire/database';
import {HelpBottomComponent} from '../help-bottom/help-bottom.component';
import {RouteConfigLoadEnd} from '@angular/router';
import {take} from 'rxjs/operators';
import * as querystring from 'querystring';

const md5 = require('md5');


/*
export class AdventureGuide {
  title: LangStringBlock;
  blog; // name of the blog publishing it
  blogukey: string;
  pubdate: number;
  stars: number; rating; // 0-5
  lang: string; // en by default

  countries: string[]; // comma deliminated list of countries
  regions: string[];
  citycountries: PlaceLoc[]; //  use google place_id
  pois: PlaceLoc[]; // Points of Interest (use consistent spelling)  -> use google place_id
  tags: string; // these are the tags
  season: string[]; // summer, autumn, etc.

  tmpsrc: string; // location of the image file from which the src is constructe
  src: string; // location of guide img - maybe use canvas to save the entire thumbnail
  link: string; // url to actual guide
  desc: LangStringBlock;
  includesAd: boolean; // true = yes

  ukey: string;

  constructor() {
    this.title = new LangStringBlock();
    this.desc = new LangStringBlock();
    this.lang = 'en';
  }
}
*/

export class PlaceObj {
  websiteurl: string;
  name: string;
  subtitle: string;
  datapid: string;
  dataurl: string;
  locatedin: string;
  address: string;
  description: string;
  descriptionsourcelink: string;
  wikipedia: string;
  britanica: string;
  mapurl: string;
  lat: number;
  long: number;
  images: string;
  kingdom: string;
  phylum: string;
  class: string;
  country: string;
}

export class AssignThread {
  name: string; // this is the name of place
  description: LangStringBlock;
  descriptionsource: string; // format note:  Wikipedia|https://en.wikipedia.org/wiki/Fallingwater
                             // the | separates the link from the name of the source
                             // this could be the article that i’m currently indexing
  namethread: string; // name of thread e.g. Alvar Aalto Designs
  threadukey: string;
  placehash: string;
  placeukey: string;
  date: string; // at some point later i may turn this into an actual date

  constructor() {
    this.description = new LangStringBlock();
  }
}

export class Thread {
  name: string;
  ukey: string;
  description: LangStringBlock;
  data: string;
  referenceurl: string;
  places: string[]; // array of placeukeys
  placeshash: any[]; // array of placehash objects {placehash: , placeukey: }

  constructor() {
    this.description = new LangStringBlock();
  }
}

export const Newscats = [
  'None', 'Politics', 'Business', 'Sports', 'Local News', 'Opinion', 'Entertainment'];


export const Programs = [
  'Guide',
  'Respondent'
];

export class Faq {
  ukey: string;
  question: LangStringBlock;
  subject: LangStringBlock;
  author: string;
  answer: LangStringBlock;
  date: number;

  constructor() {
    this.date = new Date().getTime();
    this.question = new LangStringBlock();
    this.subject = new LangStringBlock();
    this.answer = new LangStringBlock();
  }

}

export class ReferralForm {
  'Provider Name': string;
  'Provider NPI': string;
  'Medical License ID': string;
  'Name of requesting office': string;
  'Provider Email': string;
  'Provider Address': string;
  'Provider Phone Number': string;
  'Patient Name': string;
  'Patient Phone Number': string;
  'Patient Gender': string;
  'Patient Date of Birth': string;
  'Patient Address': string;
  'Insurance Name': string;
  'Patient Symptoms and History': string;
  'Member ID or Policy Number': string;
  'If child, parent or guardian name': string;
  'Group Number': string;
}

export class CovidCaseHistory {
  date: number;
  category: string;
  desc: string;
  link;
}

export class CovidNode {
  name: string;
  size: number; // approximate number of participants
  start: number;
  end: number;
  desc: string;
  address: Address;
  contacts: CaseProfile[];
  potentials: PotentialContact[];
  ukey: string;
  agentukey: string;

  constructor() {
    this.name = '';
    this.desc = '';
    this.size = 0;
    this.address = new Address();
    this.potentials = [];
  }
}

export class Doctor {
  name: string;
  ukey: string;
  license: string;
  email: string;
  locukey: string;
  phone: string;
  npi: string;
}


export class QStatus {
  lastcontact: number;
  lengthcontact: number;
  physicalcontact: boolean;
  socialdistance: boolean;
  themppe: boolean;
  youppe: boolean;
  quarantineend: number;
  quarantinestart: number;
  reason: string;
  caseukey: string;

  constructor() {
    this.lastcontact = new Date().getTime();
    this.lengthcontact = 0;
    this.physicalcontact = false;
    this.socialdistance = false;
    this.themppe = false;
    this.youppe = false;
    this.reason = '';

  }

}

export class CaseAgent {
  title: string;
  ukey: string;
  name: string;
  phone: string;
  email: string;
  pp: string; // profile pic url with https...
  id: string;
  loc: string; // the location to which the agent is assigned.
  attributes; // popluations that can be supported
  cases;

  constructor() {
    this.title = 'Contact Tracing Agent';
    this.name = '';
    this.email = '';
    this.pp = '';
    this.phone = '';

  }
}


export class PotentialContact {
  cp: CaseProfile;
  notes?: Note[];

  constructor(agentukey, org) {
    this.cp = new CaseProfile(agentukey, org);
    this.notes = [];
  }

}

export class CaseProfile {
  name: string;
  email: string;
  phoneNumber: string;
  homePhoneNumber: string;
  addresses: Address[];
  bdate: number;
  attributes: string;
  agentukey: string;
  agreed: boolean;
  corpukey: string;

  override: boolean; // === true if profile information is stored locally; false if profile information comes from Individual//profiles/base
  language: string;
  medical: MedicalCheckList;
  preexit: PreExisting;
  indivukey: string;
  parentukey: string; // used when this person has a parent who is the guardian, in which case need to get their contact data when doing a case management follow up
  caseukey: string;

  constructor(agentukey, org) {
    this.override = false;
    this.corpukey = org;
    this.name = '';
    this.addresses = [];
    this.phoneNumber = '';
    this.homePhoneNumber = '';
    this.email = '';
    this.indivukey = '';
    this.parentukey = ''; // used when this person has a parent who is the guardian, in which case need to get their contact data when doing a case management follow up
    this.agentukey = agentukey;
    this.agreed = false;
    this.bdate = -1;

    this.medical = new MedicalCheckList();
    this.preexit = new PreExisting();
  }
}

export class PreExisting {
  lung: boolean;   // chronic lung disease
  diabetes: boolean;
  obesity: boolean;
  cvd: boolean; // cardiovascular disease (CVD),
  renal: boolean; // chronic renal disease,
  liver: boolean; // chronic liver disease,
  immunocompromised: boolean;
  pregnant: boolean;
  other: string;

  constructor() {
    this.lung = false;   // chronic lung disease
    this.diabetes = false;
    this.obesity = false;
    this.cvd = false; // cardiovascular disease (CVD),
    this.renal = false; // chronic renal disease,
    this.liver = false; // chronic liver disease,
    this.immunocompromised = false;
    this.pregnant = false;
    this.other = '';
  }

}

export class MedicalCheckList {
  hospitalization: boolean; // hospitalization
  icu: boolean; // intensive care unit (ICU)
  ventilator: boolean;
  ecmo: boolean; // extracorporeal membrane oxygenation (ECMO)
  pneumonia: boolean;
  stroke: boolean;
  heatattack: boolean; // myocardial infarction (heart attack)
  other: string; // this is for a note

  constructor() {
    this.hospitalization = false; // hospitalization
    this.icu = false; // intensive care unit (ICU)
    this.ventilator = false;
    this.ecmo = false; // extracorporeal membrane oxygenation (ECMO)
    this.pneumonia = false;
    this.stroke = false;
    this.heatattack = false; // myocardial infarction (heart attack)
    this.other = ''; // this is for a note
  }
}


export class CovidQuarantine {
  lastcontact: number;
  lengthcontact: number; // in minutes
  youppe: boolean;
  themppe: boolean;
  socialdistance: boolean;
  physicalcontact: boolean;
  quarantinestart: number;
  quarantineend: number;
  reason: string;
  whoukey: string;
  whoname: string;

  constructor() {
    this.lastcontact = new Date().getTime();
    this.youppe = false;
    this.themppe = false;
    this.physicalcontact = false;
    this.socialdistance = false;
  }
}

export class CovidInfectiousPeriod {
  infectioustart: number;
  testeddate: number;
  enddate: number;
  reason: string;
}

export class CovidAction {
  date: number;
  note: string;
  bywhom: string;
  action: string;
  obj;
  type: string; // testresult, appointment, notification, survey, quetionnaire, sharecontact (means agreed to share contact list)
                // newcase (created new case file)

  constructor() {
    this.date = new Date().getTime();
  }
}

export class CovidEmployee {
  name: string;
  email: string;
  phone: string;
  phonehouse: string;
  corpid: string;
  diseases: string;
  appt: number;
  ukey: string;
  status: boolean; // true if the employee has registered the covid tracking app.
  statusdate: number;
  lastuse: number; // the last time a user used the app;
  update: string;
  updatedate: number;
  updatewho: string;
  updatenote: string;
  infectiousperiod: CovidInfectiousPeriod;
  quarantine: CovidQuarantine;
  indivukey: string;
  riskfactor: number;
  riskfactordate: number;
  caseukey: string;
  agentukey: string;
  surveys;
  actions;
  assessments;
  use: any[];

  constructor() {
    this.diseases = 'COVID-19';
  }
}

export class ROEChron {
  ukey: string;
  type: string;       // eg notification, RISD - determines what function to call to process
  l: any;             // this is the structure - eg notification form
  repeat: string;     // this is the frequency
  startdate: number;  // includes the time of day to run chron job -  ignore for now.
  enddate: number;    // upon enddate self-delete; -1 means no end date
  program: string;    // identifies who created the notification
}

export class Profile {
  type: string; // Job, Volunteer, Education, Social
  name: string;  // actual name

  username: string; // could be a fake name or a username
  bdate: number; // birthdate
  ss: string; // social security number
  orgid: string;
  addresses: Address[];

  org: string;  // org - edition NOTE: this is also the ukey
  title: string;
  start: number;
  present: boolean; // currently affiliated
  end: number;
  profilepic: string;   // proile pic
  desc: string;
  phoneNumber: string;
  email: string;
  algolia: string; // this is the name of the Algolia index that needs to be updated

  // this is for validation. probably not the best way to do it.
  status: string; // Approved -Not Approved
  approvedbydate?: number; // todo: add a little icon that indicates that an employee has been approved
  approvedbywho?: string; // todo: add a little icon that indicates that an employee has been approved

  constructor() {
    this.type = 'School'; // Job, Volunteer, Education, Social
    this.name = ''; // could be a fake name or a username
    this.org = '';  // org - edition NOTE: this is also the ukey
    this.title = '';
    this.start = new Date().getTime();
    this.end = this.start;
    this.present = true; // currently affiliated
    this.profilepic = '';   // proile pic
    this.desc = '';

    this.phoneNumber = '';
    this.email = '';
    this.algolia = ''; // todo: same as this.org

    this.username = '';
    this.bdate = -1;
    this.ss = ''; // social security number
    this.orgid = '';
    this.addresses = null;


    // this is for validation. probably not the best way to do it.
    this.status = 'Not Approved'; // Approved -Not Approved
    this.approvedbydate = -1;
    this.approvedbywho = '';

  }
}

export class Address {
  oneline: string;  // description of the address: eg Home, Work, Vacation Home
  street1: string;  // street1
  street2: string;  // street2
  city: string;  // city
  state: string;  // state
  country?: string;  // country
  zip: string;  // zipt
  county?: string; // points to the CA form
  long?: number;
  lat?: number;
  hash: string;

  constructor() {
    this.oneline = ''; //  this is the address in one line
    this.street1 = '';  // street1
    this.street2 = '';  // street2
    this.city = '';  // city
    this.state = '';  // state
    this.country = '';  // country
    this.zip = '';  // zipt
    this.county = ''; // points to the CA form
    this.long = -1;
    this.lat = -1;

  }
}


export class Editionx {
  active: boolean;
  code: string;
  description: LangStringBlock;
  logo: string;
  name: LangStringBlock;
  order: number;
  ukey: string;
  slug?: string;
  collegesCount?: number;
  iconCode?: string;
  iconColor?: string;
  iconFamily?: string;
}

export class TopixMember {
  name: string;
  roedeviceid: string;
  indivukey: string;
  role: string;
  cappteamukey: string;
  cappteamname: string;
  isprincipal: boolean;
  admins: string[];
  edition: string;
  phone: string;
  esig: string; // link to esignature
}

export class Rating {
  stars: number;
  count: number;
}

export class Topix {
  date: number;
  lastread: number; // this is the date the Topix was last viewed
  enddate: number; // this is used by Adventures for the end of a trip but it could be used for anything that is temporary
  description: LangStringBlock;
  archived: boolean;

  metadetails: any; // can be used for anything, travel blogs use it to store meta data of the blog
  edition: string;
  policyurl: string;
  confirmemployee: boolean;
  confirmpath: string;
  groupadmins: string[];
  icon: string;
  name: string;
  domain: string;
  type: string;
  org: string;
  public: boolean;
  topic: string;
  guide: string;

  empukey: string;
  ukey: string;
  objectID: string;
  adminname: string;
  adminemail: string;

  cnt: number;
  code: string; // 3 letter code for admittance to program
  prosurvey: string; // full path to profile survey of the principal
  prosurveydesc: LangStringBlock;
  teamsurvey: string; // full path to profile survey of capp Team Member

  orgsukeys: string[]; // when a topic belongs to one or more orgs, the org ukeys go here
  covidukey: string; // if following on behalf of somebody else like a child in the case of covid
  block: string; // list of blocked indivukeys

  location: string;  // the location of the user
  verified: string;
  group: any[]; // full path to each person in the group; for adventures this is a list of places going, will be useful for advertising.
  vexpires: number;

  tags: string; // comma deliminated string of tags to help with search
  details: any[];
  feed: string; // url of the feed if the type === Feed
  logo: string;
  smalllogo: string;
  mktlogo: string;
  cardimg: string;

  maxemployees: number;
  geo?: Geo; // location of the topix owner - todo: not yet implemented
  servicearea: boolean; // true if must check for service area if can subscribe
  locukey: string; // if an inst or community resource then a location is necessary
  perms: string; // this is used by Content component to list permissions for that particular content
                 // D = delete, E = Edit, M = Manage collabs, P = publish
  collaborators: Topix[];
  paid: boolean;
  rating: Rating;

  constructor(org = '') {
    this.date = new Date().getTime();
    this.description = new LangStringBlock();
    this.archived = false;
    this.public = false;
    this.paid = false;
    this.org = org;
    this.edition = '';

    this.rating = new Rating();
    this.servicearea = false;
    this.prosurveydesc = new LangStringBlock();
    this.geo = new Geo();


  }

}


export class CaresResource {
  ukey: string;
  resourcelocation: string;
  format: string;
  type: string;
  pos: number;
  location?: number[];
  distance?: number;
  abbrDesc: LangStringBlock;
  icon?: string;
  note?: string;
}

export class Horse {
  edition: string;
  organization: string;
  state: string; // for example, this is the mode: gallery or chicklet
  cursel: boolean; // is this horse the one selected when user closed the app

  puskkey?: string; // todo: unimplemented: this is the key needed to push notifications

  // todo: unimplmenented: these optional parameters are for those who have to register to use an edition
  email?: string;
  lname?: string;
  fname?: string;
  mname?: string;
  zname?: string;
  title?: string;
  phone?: string;
}


export class EdList {
  ukey: string;
}


// this table is in the Console Project
// QUESTION: is there any reason it should be in the Title IX Project?
// ANSWER?: I'm thinking it should.  Because there is no reason to keep it out
// this table is manually seeded by Capptivation

export class Edition {
  ukey: string;
  active: boolean;
  order: number;
  name: string;
  description: string;
  logo: string;
  code: string; // this is also the directory
}


// ///////////////////////////////////////////////////////////////////
// org data should is stored in the TitleIX database so that it accessible to all.
// only confidential data should be stored in the college's project


export class ROResource {
  ukey: string;
  parentkey: string; // this is the way handle inheritance
  children?: string[];
  active: boolean;
  icon: string;
  primaryservice?: string;
  jsonld: string;
  favorite?: boolean;
  abbrDesc?: LangStringBlock;
  client?: boolean;
  class?: string;
  lastup?: number;
  lasttr?: number;
}

export class OrgBase extends ROResource {
  orglegacy: OrgLegacy;
  orglegacyextra: OrgLegacyExtra;
  orgdata: OrgData;
  cappparams?: CappParams;
  privatekey?: string;
  aes?: string;
  geo: Geo;
  links: Links;
  fullpath?: string;
}


export class CappParams {
  publickey?: string;
  cappreports?: CappReports[];
}

export class CappReports {
  name: string;
  path: string;
  ukey: string;
}

export class OrgProfile extends OrgBase {
  doeid: string; // this is the DOE id
  rfctoresourceid?: string;
  rfctoreporterid?: string;
  rfcfrom?: string;
  cappid: number; // this is the link to spreadsheet data

  demo: Demographics;
  vas: OrgExtra[];
}

export class OrgData {
  contactname: string;
  contactemail: string;
  street1: string;
  street2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  phones: PhoneObj[];
  emailextentions?: string;
  cappmail: boolean;
  ronpartner: boolean;
  confidential?: boolean;
  religiousaffiliation?: string;
  orgtype?: string;
}

export class OrgLog {
  source?: string; // where did the info come from
  action?: string;
  inputer?: string;
  inputerorg?: string;
  sponsor?: string;
  date?: string;
  ukey: string;
  detail: string;
  type?: string;
}

export class UseLog {
  userdate: UserDate[];
  path: string;  // this is the path to the resource being retrieved
  roapp: string; // this is what ro app is doing the get
  ukey: string;
}

export class UserDate {
  deviceID: string;
  datetimestamp: string;
}

export class OrgLegacyExtra {
  resource_super_type_slug: string;
  short_description: string;
  schedule: string;
  is24: boolean;
  kwabid?: number;
}

export class OrgLegacy {
  name: string;
  nickname: string;
  primarycolor: string;
  secondarycolor: string;
  logo: string;
  sponsored: boolean;
  sponsor_text?: string;
  sponsor_url?: string;
  homepage_type: string;
  photo?: string;
  smalllogo?: string;
}

export class Order {
  contact: string;
  email: string;
  street1: string;
  street2: string;
  city: string;
  state: string;
  zip: string;
  agree: boolean;
  orgextra: OrgExtra;
}

export class OrgExtra {
  name: string;
  startlicensedate: string;
  expires: string; // date license agreement expires
  costperyear: number;
  paidstatus: boolean;
  acceptlicenseagreement: string; // this will be the email of the person agreeing to the terms
  licenseagreement: string;
  dateaccepted: string;
  dayexpires: number;
}

export class VAS {
  name: string;
  licenseagreement: string;
  oneyearcost: string;
  twoyearcost: string;
  threeyearcost: string;
  ukey: string;
  logo: string;
  routername: string;
  initialview: string;
}

export class OrgEdition {
  ukey: string;
  org: string;
  name?: string;
  desc: LangStringBlock;
  topics?: string[];
  image?: string;
  active: boolean;
  initialviewmode: string;
  signin: string;
  terms: string;   //  path to terms and condtions
  privacy: string; // path to privacy policy
  filter?: string;
  private: boolean; // true = edition is not viewable by public
  invcode: string; // this is the 5 letter code if it's a private edition

  constructor() {
    this.ukey = ''; // this gets created later - not now because null value is used as a key
    this.org = '';
    this.filter = '';
    this.name = '';
    this.terms = '';
    this.privacy = '';
    this.image = '';
    this.topics = [];
    this.active = false;
    this.initialviewmode = 'notify';
    this.signin = 'nr';
    this.desc = new LangStringBlock();
  }
}


export class comRec {
  link: string;
  date: number;
  name: string;
  note: string;
  admin: string;
  org: string;
  ukey: string;
}

export class InstOrg {
  ukey: string;
  lastupdate: number;

  locations: LocationData[];
  profile: InstProfile;
  editions: OrgEdition[];
  global: GlobalConfig;
  links: Links;
  archive;
  guideslist?;
  guideusers?;


  constructor() {
    this.locations = [];
    this.profile = new InstProfile();
  }

}

export class InstProfile {
  name: string;
  cappname: string;
  desc: LangStringBlock;
  active: boolean;
  globaldir: boolean; // true means include in the OrgDir index in algolia
  nickname: string;
  primarycolor: string;
  timezone: string;
  secondarycolor: string;
  emailextension: string;
  logo: string;
  smalllogo: string;
  attributes: string;
  curlang: string;

  constructor(curlang = 'en') {
    this.curlang = curlang;
    this.attributes = '';
    this.name = '';
    this.active = false;
    this.globaldir = false;
    this.desc = new LangStringBlock();
    this.primarycolor = '#0000FF';
    this.secondarycolor = '#FFFFFF';
  }
}

export class GlobalConfig {
  name: string;
  desc: LangStringBlock;
  showdesc: boolean;
  links: Links;
  affiliates: boolean;
  long: number;
  lat: number;
  members: boolean;
  partners: boolean;
  adverts: boolean; // true === accepts advertisements
  smalllogo: string;
  logo: boolean; // true === show small logo; or profile pic if individual
  editionukey: string;
  topicukey: string;
  profileukey: string;
  orgtype: string; // eg. Inst, Orgs, Community
  objectID: string;  // indivukey for an individual - also used by Algolia index
  location: string;
  locukey: string;
  staffukey: string;
  showlinks: boolean; // true === show link bar
  attributes: string; // search tags.

  constructor() {
    this.long = -1;
    this.lat = -1;
    this.showdesc = false;
    this.logo = false; // tthis.desc = true;
    this.desc = new LangStringBlock();
    this.staffukey = '';
    this.showlinks = false; // true === show link bar
    this.affiliates = false;
    this.adverts = false;
    this.members = false;
    this.partners = false;
    this.attributes = '';
  }
}

export class Org {
  ukey: string;
  archive?;
  profile: OrgProfile;
  editions: OrgEdition[];
  partners;
}

export class ComOrg {
  ukey: string;
  parentrelationship: string;
  parentkey: string; // this is the way handle inheritance
  children?: string[];
  active: boolean;
  primary?: string;
  services?: string;
  holidays: Invitation[];
  disaster: boolean;

  langHead: LangStringBlock;
  langDesc: LangStringBlock;
  abbrDesc?: LangStringBlock;

  emailextentions?: string;
  religiousaffiliation?: string;

  rfctoresourceid?: string;
  rfctoreporterid?: string;
  rfcfrom?: string;
  orgtype?: string;  // government, not-for-profit, for-profit
  timezone: string; // this should be a pick list
  publickey?: string;
  icon: string;
  isCorp: boolean; // true if this resource is also a transactional resource like a testing center

  jsonld: string;
  favorite?: boolean;
  client?: boolean;
  type: string;
  content: string; // this field is for tying a RO App to a Community resources
  archive?;

  privatekey?: string;
  aes?: string;
  class?: string;
  fullpath?: string;

  orglegacy: OrgLegacy;
  orglegacyextra: OrgLegacyExtra;
  cappparams?: CappParams;
  links: Links;
  guideslist?;
  guideusers?;
  locations: LocationData[];
  programs: ComProgram[];
  lastupdate?: number;
  lasttrans?: number;
}

export class ROEUser {
  email: string;
  photo: string;
  name: string;
  deviceId: string;
  profile: string; // ukey of the attached profile
  lastread: number;
}

export class ROEMenu {
  name: LangStringBlock;
  icon: string;
  component: string;
  candelete: boolean;

  constructor() {
    this.name = new LangStringBlock();
    this.icon = '';
    this.component = '';
    this.candelete = true;
  }
}

export class GuideList {
  descr: LangStringBlock;
  name: LangStringBlock;
  icon: string;
  tags: LangStringBlock;
  abbr: LangStringBlock;
  program: string;
  pubby: string;
  ukey: string;
  date: number;
}

export class Eligibility {
  form: string; // url to a form
}

export class LocationData {
  name?: string;
  ukey?: string;
  contactname: string;
  contactemail: string;
  phones: PhoneObj[];

  street1: string;
  street2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  geo: Geo;
  langDesc: LangStringBlock;

  comtags: string;
  comemojis: string;
  cappmail: boolean;
  deviceid?: string;

  programs: string;
  days?;
  regdays?;
  twentyfourseven?: boolean;
  closedholidays: boolean;
}

export class ComProgram {
  id: string;
  nameDesc: LangStringBlock;
  langDesc: LangStringBlock;
  contactname: string;
  contactemail: string;
  link?: string;
  logo?: string;
  phones: PhoneObj[];
  confidential: boolean;

  comlocations: string;
  comservices: string;
  comlanguages: string;
  comcommunities: string;
  comtags: string;
  comemojis: string;

  days?;
  regdays?;
  twentyfourseven?: boolean;

  cappmail: boolean;
  ronpartner: boolean;
  elig?: Eligibility;
  ukey: string;
}

export class Links {
  // section 3: link
  url: string;
  facebook: string;
  twitter: string;
  instagram: string;
  linkedin: string;
  wikilink: string;
  googleplus: string;
  pinterest: string;
  snapchat: string;
  feedback?: string;
  tumblr: string;
  youtube: string;

  constructor() {
    this.url = '';
    this.facebook = '';
    this.twitter = '';
    this.instagram = '';
    this.linkedin = '';
    this.wikilink = '';
    this.googleplus = '';
    this.pinterest = '';
    this.snapchat = '';
    this.feedback = '';
    this.tumblr = '';
    this.youtube = '';
  }
}

export class Geo {
  // section 4: geo
  county?: string;
  long: number;
  lat: number;
  rad?: number;
  timezone?: string; // this should be a pick list
  servicearea?: ServiceArea;
  backcolor?: string;
  selcolor?: string;

  east?: number;
  west?: number;
  north?: number;
  south?: number;
}

export class ServiceArea {
  countries: string;
  states: string;
  counties: string;
  cities: string;
}

export class Demographics {
  description: string;
  wikilink: string;
  female: number;
  male: number;
  type: string;
}

// Path:  Resources / Offices / + {id}
export class Office extends ROResource {
  // name: string;           // 0: Excel: name
  nameDesc: LangStringBlock;   //  0: Excel: name
  roles: string;          // 4: Excel: resource_type_codes - these are resource codes  ** needs processing
  populationcode: string; // not ix Excel
  langDesc: LangStringBlock;   // 5: Excel: long_description
  tags: string;           // 6: Excel: tags
  logo: string;           // 7: Excel: image_file_name
  confidential: boolean;  // 8: Excel: confidential_text

  contact: string;        // 9: Excel: contact_person_name
  email: string;          // 12: Excel: contact.email
  cappmail: boolean;      // 13: Excel: cappmail_enabled
  link: string;           // 14: Excel: info_url
  feedbackurl: string;    // 15: Excel: feedback_url
  emojis: string;         // 15: Excel: attributes ** needs processing inside of the import code
  hours: BizYear;         // 17: Excel: schedule    ** needs A LOT OF FIXING processing
  phones: PhoneObj[];     // 18-21: Excel: phones

  // these should start out inheriting from the parent
  street1: string;        // 22: Excel: address.line1
  street2: string;        // 23: Excel: address.line2
  location: string;       // 24: Excel: address.city
  city: string;           // 25: Excel: address.city
  state: string;          // 26: Excel: address.state
  zip: string;            // 27: Excel: address.zip

  deviceid?: string;      // this is the device id of the contact for a cappmail interaction

  long?: number;
  lat?: number;
  open?: number;

  orglegacyextra?: OrgLegacyExtra;
  staff?: string[];
}

export class LangString {
  en: string;
  es: string;
  zh_cn: string;
  vi: string;
  ar: string;
  fr: string;
  ko: string;
  ru: string;
  de: string;
  pt_pt: string;
  it: string;
  pl: string;
  translate: boolean;

  constructor() {
    Languages.forEach(l => {
      this[l.abbr] = '';
    });
  }
}

export class Komment {
  desc: LangStringBlock;  // this allows for auto translation in the future
  date: number;
  name: string;
  deviceId: number;
  up: number;  // thumbs up/ thumbs down
  down: number;

  constructor(deviceId: number, name: string) {
    this.desc = new LangStringBlock();
    this.up = 0;
    this.down = 0;
    this.date = new Date().getTime();
    this.deviceId = deviceId;
    this.name = name;
  }
}

export class CappPolicy {
  name: LangStringBlock;
  baseurl: string;
  ukey: string;
  date: number;
  author: string;

  constructor() {
    this.name = new LangStringBlock();
    this.date = new Date().getTime();
    this.author = 'Capptivation';
  }
}


// Types of policies include
//   Sexual Misconduct Policy
//   Code of Conduct
//   Consent
//   False Accusations
//   Retaliation
//   Student Rights
//   Alleged Victim Rights
//   Respondent Rights
export class Policy extends ROResource {
  nameDesc: LangStringBlock;               // 0: Excel name
  roles: string;              // 4: Excel: resource_type_codes
  langDesc: LangStringBlock;       // 5: Excel: description
  tags: string;               // 6: Excel: tags
  linkDesc: LangString;               // 14: Exce: info_url
  linkPubDate?: string;
  emojis: string;             // 16: Excel: attributes *** needs processing
  population_code: string;    // for what population eg. undergraduates, all students, faculty, all staff, responsible employees, etc.
  orglegacyextra?: OrgLegacyExtra;
}

// Types of Cards include:
//    Videos, ASR, Climate Survey, Task Force Report
export class Card extends ROResource {
  nameDesc: LangStringBlock;              // 0: Excel name
  roles: string;             // 4: Excel: resource_type_codes
  langDesc: LangStringBlock;      // 5: Excel: description
  tags: string;              // 6: Excel: tags
  linkDesc: LangString;              // 14: Exce: info_url
  linkPubDate?: string;
  emojis: string;            // 16: Excel: attributes *** needs processing
  population_code: string;   // for what population eg. undergraduates, all students, faculty, all staff, responsible employees, etc.
  orglegacyextra?: OrgLegacyExtra;
}

// Question: I think there needs to be two people profiles: one in the public
//   database and the other in the private database
//   perhaps linked by email.
//   the one in the public database should be called Staff

// Staff data
// To get the full list of this data see what I did for employees in LightonU
//   for example, needs to include description of job function, perhaps business hours, resource codes
export class PublicStaff extends ROResource {
  schoolgivenid: string;
  title: string;            // 0: Excel: name
  roles: string;            // 4: Excel: resource_type_codes - commas desparted codes that get busted apart with a parser
  langDesc: LangStringBlock;      // 5: Excel: description
  tags: string;             // 6: Excel: tags
  confidential: boolean;    // 8: Excel: confidential_text
  lname: string;         // 10: i'm gonna have to split the contact names up
  fname: string;        // 11: i'm gonna have to split the contact names up
  mname: string;
  zname: string;
  fullname?: string;
  pronouns: string;
  email: string;            // 12: Excel: contact.email
  cappmail: boolean;        // 13: Excel: cappmail_enabled
  link: string;             // 14: Excel: cappmail_enabled
  feedbackurl: string;      // 15: Excel: feedback_url
  emojis: string;           // 16: Excel: attributes ** needs processing
  hours: BizYear;           // 17: Excel: schedule    ** needs A LOT OF FIXING processing
  phones: PhoneObj[];           // 19: Excel: phones ** requires processing

  office: string;           // Not in Eccel: name of the building
  location: string;         // 22: Excel: address.line3
  photo: string;            // Not in Excel not in Excel
  populationcode: string; // Not in Excel for what population eg. undergraduates, all students, faculty, all staff, responsible employees, etc.
  titleixjob: string;
  titleixresume: boolean;

  deviceid?: string;   // the device id of the staff member if CappChat is turned on.

  long?: number;
  lat?: number;
  siblingukey: string;

  orglegacyextra?: OrgLegacyExtra;
  getsreport: boolean;    // this is true if the individual gets a report when submitted
  legacyid?: number;
  open?: number;
}

export class JumpLink extends ROResource {
  nameDesc: LangStringBlock;              // 0: Excel name
  roles: string;             // 4: Excel: resource_type_codes
  tags: string;              // 6: Excel: tags
  linkDesc: LangString;              // 14: Exce: info_url
  linkPubDate?: string;
  emojis: string;            // 16: Excel: attributes *** needs processing
  population_code: string;   // for what population eg. undergraduates, all students, faculty, all staff, responsible employees, etc.
  numberuses?: number;        // this keeps track of how many links there are to a resources
  start?: number;             // this keeps track of how many likes or stars a resource gets
  format: string;
  embedded: boolean;
  height: number;
  width: number;
  orglegacyextra?: OrgLegacyExtra;

}


// ////////////////////////////////////////
// todo: we have to link Persons and Staff via their emails? or perhaps, give them identical keys?
export class Person extends ROResource {
  lname: string;
  fname: string;
  mname: string;
  zname: string;
  fullname: string;
  pronouns: string;
  schoolgivenid: string;
  title: string;
  role: string;
  subrole: string;
  email: string;
  phone1: string;
  phone2: string;
  active: boolean;
  photo: string;
  titleixjob: string;
  adjudicator: boolean;
  cappmail: boolean;
  confidential: boolean;
  device_id: number;
  siblingukey: string;
  asofdate: number; // this is the date the person started with the org
  orglegacyextra?: OrgLegacyExtra;
}

export class PersonLog {
  date: number;
  type: string;
  numberrecs: string;

  constructor(date, type, numberrecs) {
    this.date = date;
    this.type = type;
    this.numberrecs = numberrecs;
  }
}

export class Resume {
  ukey: string;
  currentjob: string;
  oldjobs: string;
  training: string;
  conflicts: string;
  bias: string;
  adjudication: boolean; // this doesnt belong here

}


// this is used for importing personell data from a CSV.
// obviously the columns of the csv must match up
export class List {
  asofdate: number;  // this is the date the person started with the org
  fname: string;
  lname: string;
  mname: string;
  zname: string;
  pronouns: string;
  title: string;
  email: string;
  phone1: string;
  phone2: string;
  location: string;
  role: string;
  subrole: string;
  photo: string;
  titleixjob: string;
}


// This interface is for courses as seen by a person
// todo: probably can delete this.
export class Course {
  course_id: string;
  title: string;
  lesson: Lesson[];
  completed: boolean;
  completeddate: Date;
}

// This interface is part of Courses
// todo: Probably can delete this
export class Lesson {
  date: Date;
  completed: boolean;
}

// This is the definition of a Course
export class CourseDefinition {
  course_id: string;
  title: string;
  description: string;
  format: string; // e.g. online, seminar, event, etc.
  guideukey: string; // this is the
  moreinfourl: string;
  gspoints: number;
  gspId: string;
  required: boolean; // is the course required or not
  target: string; // this is an array of type of people who are required to take course
  date: number;    // this is the start date
  time: string;
  completiondate: number; // this is the date the course is due
  enrolled: Enrolled[];
  calendarid: string;
  chat: boolean; // true if there will be a moderator
  moderator: string; // this is name of the moderator
  modtitle: string;
  moddeviceid: number; // device number of the moderator
  ukey: string;
}

export class Enrolled {
  email: string;
  datecompleted: string;
  audit: any[]; // this is to create an audit trail of warnings for those who haven't completed the course
}

export class StateLaw {
  state: string;
  name: string;
  status: string;
  target: string;
  lastupdate: number;
  lastchange: number;
  description: string;
  sponsor: string;
  billsURL: string;
  articleURL: string;
  bipartisan: string;
  tags: string;
}

export class TmpMap {
  id: number;
  type: string;
  subtype: string;
  path: string;
  pos: number;
  name: string;
  title: string;
  emojis: any;
  progukey?: string;
  locukey?: string;
  isloc?: boolean;
}

export class Category extends ROResource {
  langDesc: LangStringBlock;
  rowidget: string;
  map: TmpMap[];
  // string[];  // college.office,view,ukey   community,view,ukey    library,ukey   category,view,ukey
}

export class MapCategory {
  nameDesc: LangStringBlock;
  icon: string;
  ukey: string;
  location: string;
  pos: number;
  elements: MapCategoryElement[];
}

export class MapCategoryElement {
  ukey: string;
  description: string;
  long: number;
  lat: number;
  location?: string; // this is where the element can be found in the database: offices/staff or Community
  street1?: string;
  street2?: string;
  city?: string;
  state?: string;
  zip?: string;
  path?: string;
  country?: string;
  county?: string;
  phone?: string;
  link?: string;
}

export class LangStringBlock {
  en: BlockString;
  es: BlockString;
  zh_cn: BlockString;
  vi: BlockString;
  ar: BlockString;
  fr: BlockString;
  ko: BlockString;
  ru: BlockString;
  de: BlockString;
  pt_pt: BlockString;
  it: BlockString;
  pl: BlockString;
  translate?: boolean;

  constructor() {
    Languages.forEach(l => {
      this[l.abbr] = new BlockString();
      this[l.abbr].description = '';
      this[l.abbr].block = false;
    });
  }
}

export class BlockString {
  description: string;
  block: boolean;
}

export class ContentLibrary {
  ukey: string;
  pubdate: string;
  name: string;
  format: string;  // pdf, website
  mustread: string;
  behavior: string;
  topic: string;
  population: string;
  costtoread: boolean;
  publication: string;
  author: string;
  title: string;
  URL: string;
  summary: string;

  CapptivationURL?: string; // this is the location in the Google Bucket of this content
  rating?: number;  // this is the average rarting of users
  ratingdetails?: RatingDetails[];
  surveyform?: string; // url to a feedback survey - NOT IMPLEMENTED
}

export class RatingDetails {
  date: number; // this is the date the review was made
  rateremail: string; // this is the email of the person submitting the rating
  rating: number;
  comment: string;
  surveyukey: string; // this is the link to the user's survey response: NOT IMPLEMENTED
}

export class MyLibrary {
  docukey: string;
}


export class ArchiveLibrary {
  ukey: string;
  pubdate: string;
  dateadded: string;
  author: string;
  title: string;
  publication: string;
  format: string;  // pdf, website
  URL: string;
  topic: string;
  behavior: string;
  population: string;

  headline: string;
  summary: string;
  name: string;  // this is the name of the organization it applies to

  target: string;
  scope: string;
  mustread: string;
  costtoread: boolean;
  filename: string;
  CapptivationURL?: string; // this is the location in the Google Bucket of this content
  rating?: number;  // this is the average rating of users
  surveyform?: string; // url to a feedback survey - NOT IMPLEMENTED
}

export class TouristBoard {
  ukey: string;
  websitename: string;
  websiteurl: string;
  icon: string;
  org: {
    name: string;
    email: string;
  };
  logo: {
    url: string;
    backgroundcolor: string;
  };
  destination: {
    countrycode: string;
    name: string;
    country: string;
    loc: string;
    ukey: string;
  };
  locations: {
    hash: string;
    lat: number;
    long: number;
    loc: string;
    viewport: {
      nelat: number;
      nelng: number;
      swlat: number;
      swlng: number;
    }
  }[];
  socialmedia: {
    instagram: string;
    youtube: string;
    tiktok: string;
    facebook: string;
    pinterest: string;
    twitter: string;
    snapchat: string;
    flickr: string;
    weibo: string;
    google: string;
    whatsapp: string;
    linkedin: string;
    issuu: string;
    reddit: string;
    tumblr: string;
    tripadvisor: string;
  };
  socialmediakeys: {
    instagram: string;
    youtube: string;
    tiktok: string;
    pinterest: string;
    snapchat: string;
    twitter: string;
  };
  blog: {url: string, note: string, feed: string};

  introvideo: string;
  photos: any[];
  website: {
    workInIframe: boolean;
    attractionsurl: string;
    destinationsurl: string;
    eventurl: string;
    offersurl: string;
    somethingspecialurl: string;
    accessibleurl: string;
    tourguidesurl: string;
    UNESCOurl: string;
    downloadsurl: string;
    luggageurl: string;
    publictoiletsurl: string;
    scenicspots: string;
    faqurl: string;
    muslimurl: string;
    officesurl: string;
    livechat: boolean;
    beachesurl: string;
    LGBTQurl: string;
    itinerariesurl: string;
    mapurl: string;
  };
  appstemp: string;
  cardtemp: string;


  vendors:
    {
      name: string;
      status:
        {
          date: number;
          status: string;
        }[]
    }[];
  localpubs: {
      pubname: string;
      puburl: string;
    }[];
  apps: {
      name: string;
      link: string;
      note: string;
      platform: string;
      type: string;
    }[];

  constructor() {
    this.appstemp = '';
    this.websitename = '';
    this.cardtemp = '';
    this.websiteurl = '';
    this.icon = '';
    this.introvideo = '';
    this.vendors = [];
    this.locations = [];
    this.localpubs = [];
    this.apps = [];
    this.org = {
      name: '',
      email: ''
    };
    this.destination = {
      countrycode: '',
      name: '',
      country: '',
      loc: '',
      ukey: '',
    };
    this.socialmedia = {
      instagram: '',
      youtube: '',
      tiktok: '',
      facebook: '',
      pinterest: '',
      snapchat: '',
      twitter: '',
      flickr: '',
      weibo: '',
      google: '',
      whatsapp: '',
      linkedin: '',
      issuu: '',
      reddit: '',
      tumblr: '',
      tripadvisor: '',
    };
    this.socialmediakeys = {
      instagram: '',
      youtube: '',
      tiktok: '',
      pinterest: '',
      snapchat: '',
      twitter: '',
    };
    this.blog = {
      url: '',
      note: '',
      feed: ''
    };
    this.website = {
      workInIframe: false,
      attractionsurl: '',
      destinationsurl: '',
      eventurl: '',
      offersurl: '',
      somethingspecialurl: '',
      accessibleurl: '',
      tourguidesurl: '',
      UNESCOurl: '',
      downloadsurl: '',
      luggageurl: '',
      publictoiletsurl: '',
      scenicspots: '',
      faqurl: '',
      muslimurl: '',
      officesurl: '',
      livechat: false,
      beachesurl: '',
      LGBTQurl: '',
      itinerariesurl: '',
      mapurl: '',
    };
    this.logo = {
      url: '',
      backgroundcolor: '',
    };
  }
}

export class Widget {
  abbrDesc: LangStringBlock;
  desc: LangStringBlock;
  ukey: string;
  tag: string;
  image: string;
  icon: string;
  topics?: string[];  // used as a filter for Directory
  editions?: string[];
  switches;             // in notifications, true = allows to ask question
  bystander?: boolean; // used by exhivbit to say whether or not a non-admin can add an exhibit.
                       // used by notification to say wheter or not a non-admin can add a notification
  constructor() {
    this.abbrDesc = new LangStringBlock();
    this.desc = new LangStringBlock();
    this.editions = [];
    this.bystander = false;
  }
}


export class Slg {
  ukey: string;
  type: string;
  generic: any;
  slgarray: SlgDesc[];
}

export class SlgDesc {
  source: string; // this serves as the ukey
  description: LangStringBlock;
  contributor?: string;
  rating?: number;
  usage?: number;
}

/*
export class MenuItem {
  ukey: string;
  icon: string;
  abbrDesc: LangStringBlock;
  location: string;
  type: string;
  mark: string;
}
*/

export class LandingBox {
  mark: string;
  maticon: string;

  ukey: string;
  icon: string;
  abbrDesc: LangStringBlock;
  desc?: string;
  location: string;
  type: string;
  pos?: number;

  constructor() {
    this.abbrDesc = new LangStringBlock();
  }
}

export class Phone {
  ukey: string;
  image: string;
  externalheight: number;
  externalwidth: number;
  internaltop: number;
  internalleft: number;
  internalheight: number;
  internalwidth: number;
  radius: number;
}

export class TmpInherit {
  val: boolean;
  name: string;
  ukey: string;
}

/*
title: string;
start: string;
gsppoints: number;
gspId: string;
*/


export class Goal {
  cappteamukey: string; // this is the cappteam to which the goal belongs;
  principal: string; // this is the name of the person who is the object of the goal; '' means the principal is the user
  forwhom: string; // roedeviceid of the target of the goal;
  path: string;
  start: number;  // this is when the goal begins and the time to complete the goal by
  descr: string;
  type: string; // eg Physical, Social, Solitary
  code: string; // this is the id of the element to connect it with other elements - for example, the id of a medication or of a measurement
  repeat: string; // the repeat frequency
  minutesbefore: number; // how many minutes before a goal is due to send an FCM notification
  ukey: string;
}

export class Rsvp {
  attend: boolean;
  indivukey: string;
  note: string;
  name: string;
}

export class Invitation {
  end: number;
  start: number;
  allDay: boolean;
  repeat: string;
  repeatID: string; // this is a way to find all events spawned from a repeat
  rsvp: number;
  height: number;
  width: number;
  pubev: boolean;  // stands for public event - for community this means show description

  title: string;
  format: string;
  ukey: string;
  creator: string; // ukey of the person creating the event.

  pitchDesc: LangStringBlock;
  headlineDesc: LangStringBlock;
  location: string;
  long: number;
  lat: number;
  contact: string;
  sponsor: string; // for community resources this equals the id of the program
  photo: string;  // this is a full google storage path to the photo used in the invitation
  link: string;   // this is the more information link
  type: string;   // this is the type of event. Important to get filtering to work.
  blocked: string;

  gspoints: number;
  gspId: string;  // for community resource this equals the name of the location
  cappteamId: string;

  len: number;    // length of event in minutes

  /*
      orged?: string;
  */

  l: any;
  textcolor: string;
  textcolor2: string;
  backgroundcolor: string;
  backgroundcolor2: string;
  respath: string;
  tls: TLS[];
  lastupdated?: number;
  lasttrans?: number;
  todo: boolean; // true if task completed
  assigned: string; // the indivukeys of people taking up the todo.

  constructor() {
    this.allDay = false;
    this.len = 30;
    this.pubev = false;
    this.title = '';
    this.format = 'none';
    this.repeat = '';
    this.repeatID = '';

    this.pitchDesc = new LangStringBlock();
    this.headlineDesc = new LangStringBlock();

    this.location = '';
    this.long = -1;
    this.lat = -1;
    this.width = -1;
    this.contact = '';
    this.sponsor = ''; // for community resources this equals the id of the program
    this.photo = '';  // this is a full google storage path to the photo used in the invitation
    this.link = '';

    this.gspoints = 0;
    this.gspId = '';

    this.len = 30; // this is the length of the event

    this.textcolor = '';
    this.textcolor2 = '';
    this.backgroundcolor = '';
    this.backgroundcolor2 = '';
    this.respath = '';
    this.tls = null; // todo: not sure what this does
    this.height = -1;
    this.lastupdated = -1;
    this.lasttrans = -1;
  }
}

export class TLS {
  pitchDesc: LangStringBlock;
  headlineDesc: LangStringBlock;
  path: string;
}


/*
export class FCEvent extends Invitation {
    id: string; // this is the ukey
    end: string;
    allDay: boolean; // false means show time
    pubev: boolean;

}
*/


export class Guide {
  name: LangStringBlock;
  description: LangStringBlock;  // todo: shouldn't this be a LangStringBlock?
  class: string;
  kwabid: number;
  abbr: LangStringBlock;
  ukey: string;
  target: string;
  icon: string;
  slug: string;
  id: number;
  program: string;
  typeoftoc?: string;
  toclogo?: string;
  base64location: string;
  requiresignin?: boolean;

  gspoints?: number;
  gspWidgetUkey?: string;  // for community resource this equals the name of the location
  gspProgram?: string;

  toctitle: LangStringBlock;
  copyright?: LangStringBlock;
  read?: boolean;
  notices?: GuideNotice[];
  chat?: boolean;
  uselogo?: boolean;
  webapp?: boolean;
  usearia: boolean;
  moderator: string;
  modtitle: string;
  moddeviceid: number;
  guideintro?: GuideIntro;
  guideend?: GuideEnd;
  langs?: string;
  pages?;
  publish?: boolean;
  pubby?: string;
  descr?: LangStringBlock;
  tags?: LangStringBlock;
  sponsor?: string;
}

export class GuideIntro {
  intrologo: string;
  introtext: LangStringBlock;
  privacypolicy: string;
  regop: string;
}

export class GuideEnd {
  endlogo: string;
  endtext: LangStringBlock;
  certificate: boolean;
  confirm: boolean;
}


export class GuideNotice {
  title: string;
  body: string;
}

export class GSP {
  points: number;
  ukey: string; // should rename to a ukey
  name: LangStringBlock; // should be a LangStringBlock
  desc: LangStringBlock; // should have a description
  date: number;
  creator: string;
  category: string; // e.g. Activity, Action, Education Module, Event, Survey, Quick Take

  constructor() {
    this.name = new LangStringBlock();
    this.desc = new LangStringBlock();
  }
}

export class GSPReward {
  name: string;
  expires: string;
  quantity: number;
  quantityused: number;
  usebydate: string;
  points: number;
  description: string;
  instructions: string;
  image: string;
  ukey: string;
}

export class GSPRedeem {
  email: string;
  date: string;
  ukey: string;
  id: string;
  name: string;
  description: string;
  instructions: string;
  redeemed: string;
}

export class GSPDeviceRedeem {
  name: string;
  programId: string;
  points: number;
  date: string;
  ukey: string;
}

export class Receiver {
  ukey: string;
  byemail: boolean;
  byphone: boolean;
  notice: boolean;
  fullreport: boolean;
  name: string;
  phone: string;
  email: string;
  title: string;
}

export class CappSurveyForm {
  ukey: string;
  name: LangStringBlock; // name of survey
  abbrDesc: LangStringBlock;
  desc: LangStringBlock;
  simplesum: boolean;  // true = means value of all questions added to create a survey value
  forprincipal: boolean; // true = means person is to answer questions about the principal. false = answer about yourself

  sdate: number; // start of survery period
  edate: number; // end of survey period
  icon: string;

  tdate: number; // date survey taken
  survey: LangStringBlock;
  deviceId: number;
  org: string; // creator of survey
  author: string;
  results: any;

  gspoints?: number;
  gspWidgetUkey?: string;  // for community resource this equals the name of the location
  gspProgram?: string;

  eventukey?: string;
  measure: boolean; // true if store in Measures; false store results regular


  constructor() {
    this.name = new LangStringBlock();
    this.abbrDesc = new LangStringBlock();
    this.desc = new LangStringBlock();
    this.survey = new LangStringBlock();
    this.sdate = new Date().getTime(); // start of survery period
    this.edate = this.sdate; // end of survey period
    this.icon = '';
    this.gspoints = 0;
    this.measure = false;
    this.simplesum = false;
  }
}

export class CappReportForm {
  name: LangStringBlock;
  description: LangStringBlock;
  explanation: LangStringBlock;
  disclaimer: LangStringBlock;
  sections: CappReportSection[];
  abbr: LangStringBlock;
  base64location: string;
  program: string;
  slug: string;
  class?: string;
  kwabid?: number;
  tags: string;
  langs?: string;
  emojis: string;
  id: number;
  icon: string;
  ukey: string;
  receivers?: Receiver[];
  orglegacyextra?: OrgLegacyExtra;
  roappres?: ROAppRes;
  console: boolean;
  lastupdated?: number;
  lasttrans?: number;
}

export class Exhibit {
  ukey: string;
  description: string;
  filepath?: string;
  thumbpath: string;
  type: string;
  link?: string;
  creator: string;
  date: number;
  users?: ExhibitUser[];
  tags?: string;
  creatorname?: string;
  commentpath: string;
  orgpath: string;
  edition: string;
  likes: number;
  heart: boolean;
  long: number;
  lat: number;
  location: string;
  app: string;
}

export class Comment {
  desc: LangStringBlock;  // this allows for auto translation in the future
  date: number;
  name: string;
  deviceId: string;
  up: number;  // thumbs up/ thumbs down
  down: number;

  constructor(deviceId: string, name: string) {
    this.desc = new LangStringBlock();
    this.up = 0;
    this.down = 0;
    this.date = new Date().getTime();
    this.deviceId = deviceId;
    this.name = name;
  }
}

export class ExhibitUser {
  deviceid: number;
  exhibitsread: boolean;
  exhibitsadd: boolean;
  exhibitsdelete: boolean;
  exhibitsdownload: boolean;

  constructor() {
    this.exhibitsread = false;
    this.exhibitsadd = false;
    this.exhibitsdelete = false;
    this.exhibitsdownload = false;
  }

}

export class Page {
  ukey: string;
  name: LangStringBlock;
  elements: PageElement[];
  pos: number;
  tocurl?: LangString;
  tocaria?: LangStringBlock;
  tocheight?: number;
  tocwidth?: number;
  minminutes?: number;
}

export class PageElement {
  ukey: string;
  type: string;
  aria?: LangStringBlock;
  name: LangStringBlock;
  body: LangStringBlock;
  alt?: LangStringBlock;
  fullpath: string;
  poster?: string;
  aspect: number;
  percentwidth: number;
  iframe?: boolean;
  pos: number;
  rfc: boolean;
  question?: Question;
}

export class Question {
  question: LangStringBlock;
  answer: Answer[];
}

export class Answer {
  correct: boolean; // true if correct answer
  answer: LangStringBlock;
  response: LangStringBlock;
}


export class TocChicklet {
  imageurl: string;
  page: number;
  tocheight: number;
  tocwidth: number;

}


export class CappReportSection {
  name: LangStringBlock;
  description: LangStringBlock;
  explanation: LangStringBlock;
  style: string;  // ReportSectionStyles;
  ukey: string;
  fields: CappReportField[];
  pos: number;
  lastupdated?: number;
  lasttrans?: number;
}

export class CappReportField {
  name: LangStringBlock;
  description: LangStringBlock;
  explanation: LangStringBlock;
  type: string;   // ReportFieldTypes
  code: string;
  relationshipstoorgz?: LangStringBlock;
  relationshiptoyouz?: LangStringBlock;
  optionsz?: LangStringBlock;  // this applies for select, checkboxes, individuals types
  rolesz?: LangStringBlock;
  required?: boolean;
  values?: string[];
  individuals?: Individual[];
  other?: string;
  multiple?: boolean;
  ukey: string;
  lastupdated?: number;
  lasttrans?: number;
  exhibits?: Exhibit[];
}

export class Individual {
  name: string;
  description: string;
  relationshiptoorg: string;
  relationshiptoyou: string;
  role: string;
  phone: string;
  email: string;
  facebook: string;
}

export class CappReportFilledOut {
  header: Header;
  sections: CappReportFilledOutSection[];
}

export class CappReportFilledOutSection {
  name: string;
  values: CappReportFilledOutValue[];
}

export class CappReportFilledOutValue {
  name: string;
  value: string;
}

export class ReportField {
  name: string;
  value: string;
}


export class Header {
  timestamp: string;
  curlang: string;
}

export class You {
  fname: string;
  lname: string;
  mname: string;
  relationshiptoorg: string;
  role: string;
  phone: string;
  email: string;
}

export class Entry {
  dateofentry: number;
  name: string;
  nameofentry: string;
  typeofentry: string;
  filepath: string;
  submit?: boolean;
  incidentid: string;
  ukey: string;
}

export class IncidentEntry {
  ukey: string;
  dateofentry: number;
  name: string;
  status: string;
  phone?: string;
  email?: string;
  relationshiptoorg?: string;
  parties?: Party[];
  reports?: IncidentReportEntry[];
  exhibits?: Exhibit[];
  timeline?: Checklist[];
  notifications?: any;
  adjudicators?: any;
  checklist?: Checklist[];
}

export class Accommodation {
  date: string;
  content: string;
  type: string;
}

export class Checklist {
  date: number;
  time: string;
  days: number;
  ukey: string;
  topic: string;   // e.g Accommodations
  name: string;
  calendarid?: string;
  description: string;
  respondent: boolean;
  complainant: boolean;
  items: CheckItem[];
  respondentcompleted: boolean;
  complainantcompleted: boolean;
  respondentdatecompleted: string;
  complainantdatecompleted: string;
  respondenthow: string;
  complainanthow: string;
  location: string;
  parties: string[];
  notifyviaemail: boolean;
  posttomessages: boolean;
}

export class TmpEmail {
  emails: string;
  from: string;
  checklist: Checklist;
}


export class CheckItem {
  name: string;
  completed: boolean;
}

export class IncidentReportEntry {
  ukey: string;
  dateofentry: number;
  nameofentry: string;
  typeofentry: string;
  deviceid: number;
  name?: string;
  phone?: string;
  email?: string;
  filepath: string;
  submit?: boolean;
  report?: CappReportForm;
}


export class Party {
  name: string;
  phone?: string;
  email?: string;
  relationshiptoorg?: string;
  role?: string;
  deviceid: number;
  path: string; // this is how we get information about the individual
  method: string;
  notes: Note[];
  ukey: string;
  color: string;
  permissions: Permissions;
  users?: UserPermit[];
  accommodation?: Accommodation[];
  partypath?: string;

  constructor() {
    this.name = '';
    this.partypath = '';
    this.phone = '';
    this.email = '';
    this.role = '';
    this.deviceid = -1;
    this.relationshiptoorg = '';
    this.path = '';
    this.method = '';
    this.notes = [];
    this.color = '#000000';
    this.permissions = new Permissions();
    this.accommodation = [];
    this.users = [];
  }
}

export class UserPermit {
  deviceid: number;
  read: boolean;
  chat: boolean;
  delete: boolean;

  constructor() {
    this.read = false;
    this.delete = false;
    this.chat = false;
  }
}

export class Permissions {
  exhibitsread: boolean;
  exhibitsadd: boolean;
  exhibitsdelete: boolean;
  exhibitsdownload: boolean;

  notesread: boolean;
  notesadd: boolean;
  notesdelete: boolean;

  eventsread: boolean;
  eventsadd: boolean;
  eventsdelete: boolean;

  constructor() {
    this.exhibitsread = false;
    this.exhibitsadd = false;
    this.exhibitsdelete = false;
    this.exhibitsdownload = false;

    this.notesread = false;
    this.notesadd = false;
    this.notesdelete = false;

    this.eventsread = false;
    this.eventsadd = false;
    this.eventsdelete = false;
  }
}

export class Conversation {
  conversationid: string;
  paths: string[];
  messages: MessageForm[];
  first: boolean;
}

export class MessageForm {
  from: string;
  body: string;
  date: string;
  first: boolean;
}

export class NotificationForm {
  to: string;
  from: string;
  subject: string;
  body: string;
  date: number;
  icon?: string;
  image?: string;
  caller?: string;

  gspoints?: number;
  gspWidgetUkey?: string;  // for community resource this equals the name of the location
  gspProgram?: string;

  copied?: string; // todo: ??? what is this for
  cappteammsg?: CappTeamMsg; // todo: can't remember what i'm doing with this.

  fullbody?: LangStringBlock;
  deeplink?: string;  // not sure how to implement
  ukey: string;

  constructor(to, from) {
    this.fullbody = new LangStringBlock();
    this.deeplink = '';
    this.to = to;
    this.from = from;
    this.subject = '';
    this.body = '';
    this.date = new Date().getTime();
    this.ukey = this.date.toString();
    this.copied = '';
    this.caller = '';
    this.icon = '';
    this.cappteammsg = new CappTeamMsg('', this.from, '', '');
    this.cappteammsg.date = this.date;
    this.cappteammsg.ukey = this.ukey;
  }
}


export class CappTeamMsg {
  s?: string; // subject of the message
  ssoc: LangStringBlock;
  msg: string;
  dl?: string;  // dl = deeplink - this is the full path to an widget, event  or app
  ark: boolean; // true = archived

  fullmsg: LangStringBlock;
  curlang: string; // this is the language that the message is in
  date: number;
  alt: string;
  c?: string; // confetti style
  as: boolean; // allow social media commentary and likes
  cn: string; // name of the person of who the message is from
  cf: string; // the full path of who the message is from
  ty?: string; // type of message: N=notification; P = 'photo'
  l?: any; // link to other data structure needed for the Wall or the CappTeam name
  g?: string; // url of graphic
  x?; // date when message expires
  i?: string; // incident path - for ROI or the CappTeam ukey
  m?: any;  // for a step type notification m = number of steps;
  e?: any; // full path to event
  parties; // people who get the notification
  app: string;
  dt?: string; // dt = deeptype - this is the type of attachment - eg Survey, Guide, Report,
  ukey: string;
  topics: string; // this is the topic id to send a notification to if the ty === social
  trigger: string; // this is what could trigger a notification when the event happens like Welcome.
  targets: string; // this is a comma deliminated string of the demo targeted by the writer/publisher
  counts: TopixCounts;
  tandl: any; // teams and lists {name, type, ukey} type = sl for shared list, t for cappteam, l for regular list; ukey = location of list or team
  share: NotificationShare;
  v: string; // verified
  vex: number; // verified expires; also when an instagram expires
  flip: boolean;
  orgsukeys: string[];
  read: boolean;
  dept: string; // ukey of the department an inst message should be routed
  id: string; // employee id of person in the dept a message should e routed

  constructor(profile, name, type, app, lang?: string) {
    if (lang) {
      this.curlang = lang;
    } else {
      this.curlang = 'en';
    }
    this.counts = new TopixCounts();
    this.as = false;
    this.app = app;
    this.date = new Date().getTime();
    this.ukey = this.date.toString();
    this.ark = false;
    this.s = '';
    this.alt = '';
    this.tandl = [];
    this.fullmsg = new LangStringBlock();
    this.ssoc = new LangStringBlock();
    this.msg = '';
    this.cn = name;
    this.cf = profile;
    this.l = null;
    this.g = '';
    this.ty = type;
    this.parties = [];
    this.v = 'U'; // un verified
    this.vex = -1; // doesn't expire
    this.flip = false;
    this.read = false;
  }
}

// By making MapItem extend a CappTeamMsg it becomes easier to like and add comments, and notifications get build automatically
export class MapItem extends CappTeamMsg {
  // duplicate
  date: number; // this is very useful when showing a timeline inside a map


  location: PlaceLoc;
  finlocation: PlaceLoc;
  findate: number;

  marker: string;
  googlepid: string;  // Point of Interest Id
  googleurl: string;  // pin points location on googl map
  items: Asset[];
  datesaved: number;

  mode: string;
  country: string;
  state: string;
  timezoneoffset: number;
  companions: string; // indivuey+profile ???
  compphotos: string[]; // profile photo of companions
  private: boolean; // true means only collaborators can view
  dayssince: number; // days since the start of the trip
  ukey: string;
  overviewpoly: string; // this is the encoded list of points that comprise a route segment

  constructor(indivukey: string, companions: Topix[]) {
    super('', '', '', '', '');

    this.items = [];
    this.location = new PlaceLoc();
    this.finlocation = new PlaceLoc();
    this.marker = 'red';
  }
}


/*
export class CappTeamMsg {
  s?: string; // subject of the message
  ssoc: LangStringBlock;
  msg: string;
  fullmsg: LangStringBlock;
  date: number;
  curlang: string;
  alt: string;
  c?: string; // confetti style todo: change this to an array with parameters so that the user can create their own style
  as: boolean; // allow social media commentary and likes
  cn: string; // name of the person of who the message is from
  cf: string; // the full path of who the message is from
  ty?: string; // type of message: N=notification; P = 'photo'
  l?: any; // link to other data structure needed for the Wall or the CappTeam name
  m?: any;
  g?: string; // url of graphic
  x?; // date when message expires
  i?: string; // incident path - for ROI or the CappTeam ukey
  e?: string; // full path to event
  parties; // people who get the notification
  app: string;
  dl?: string;  // dl = deeplink - this is the full path to an widget, event  or app
  dt?: string; // dt = deeptype - this is the type of attachment - eg Survey, Guide, Report,
  ukey: string;
  topics: string; // this is the topic id to send a notification to if the ty === social
  trigger: string; // this is what could trigger a notification when the event happens like Welcome.
  counts: TopixCounts;
  share: NotificationShare;
  v: string; // verified
  vex: number; // verified expires
  flip: boolean;
  orgsukeys: string[];

  constructor(profile, name, type, app, lang?: string) {
    this.counts = new TopixCounts();
    if (lang) {
      this.curlang = lang;
    } else {
      this.curlang = 'en';
    }
    this.app = app;
    this.as = false;
    this.date = new Date().getTime();
    this.s = '';
    this.alt = '';
    this.fullmsg = new LangStringBlock();
    this.ssoc = new LangStringBlock();
    this.msg = '';
    this.cn = name;
    this.cf = profile;
    this.l = null;
    this.g = '';
    this.ty = type;
    this.parties = [];
    this.v = 'V'; // un verified
    this.vex = -1; // doesn't expire
    this.flip = false;
    this.trigger = 'None';
  }
}
*/

export class NotificationShare {
  name: string;
  path: string;  // this is the path to their profile
  comment: string;
  pic: string;

  constructor(name: string, path: string, comment: string, pic: string) {
    this.name = name;
    this.path = path;
    this.comment = comment;
    this.pic = pic;
  }
}

export class CappTeamParty {
  name: string;
  status: boolean; // false if invited, true if accepted
  photo: string; // url of profile photo
  indivukey: string;
  color: string;
  // role and permission can be editted only by the Admin
  role: string; // admin, doctor, lawyer, advocate, friend, family, contact
  permissions;
  drive: boolean;
  cappteamukey: string;

  constructor(name: string, indivukey: string, status: boolean, admin: boolean, photo?: string) {
    this.name = name;
    this.indivukey = indivukey;
    this.status = status;
    if (photo) {
      this.photo = photo;
    }
  }
}

export class TopixCounts {
  likes: number;
  views: number;
  comments: number;
  shares: number;
  flips: number; // flipped the card
  reads: number; // read article
  rsvp: number;
  moreinfo: number;
  calls: number;
  maps: number; // number of times clicked on map
  viewprofile: number;
  follow: number;
  unfollow: number;

  constructor() {
    this.likes = 0;
    this.views = 0;
    this.comments = 0;
    this.shares = 0;
    this.flips = 0; // flipped the card
    this.reads = 0; // read article
    this.rsvp = 0;
    this.moreinfo = 0;
    this.calls = 0;
    this.maps = 0; // number of times clicked on map
    this.viewprofile = 0;
    this.follow = 0;
    this.unfollow = 0;
  }

}


export class Note {
  date: number;  // use the date as the ukey
  summary: string;
  note: string;
  creator: string; // ukey of the person creating the note
  lastread: number;
  ukey: string;
}

export class FileEntry {
  name: string;
  description: string;
  dateinquestion: string;
  typeoffile: string;
  url: string;
  ukey: string;
}

export class NoteEntry {
  name: string;
  dateinquestion: string;
  description: string;
  ukey: string;
}


export class BreadCrumb {
  crumb: LangStringBlock;
  ukey: string;
}

export class MenuGroup {
  group: Menu;
  open: boolean;
  children: Menu[];
}


export class CAPhoneObj {
  phdescription: string;
  digits: string;
}

export class CAROResource {
  ukey: string;
  parentkey: string; // this is the way handle inheritance
  active: boolean;
  icon: string;
  abbr?: string;
}

export class CAOrgBase extends CAROResource {
  contactname: string;
  contactemail: string;
  orgdata: CAOrgData;
  graphics: CAGraphics;
  geo: CAGeo;
  links: CALinks;
}

export class CAOrgProfile extends CAOrgBase {
  doeid: string; // this is the DOE id
  cappid: number; // this is the link to spreadsheet data

  demo: CADemographics;
  orgeditions: CAOrgEdition[];
}

export class CAOrgEdition {
  editionkey: string;
  menuname: string;
  active: boolean;
  initialviewmode: string;
  cappmail: boolean;
  userprofilesenabled: boolean;
  signinrequired: boolean;
  name?: string;
}

// Question: is it better to put this data in objects or simply make OrgProfile bigger?
// Is the answer to the question dependent on how the iOS/Android apps consume the data.
export class CAOrgData {
  // section 1: data
  name: string;
  nickname: string;
  street1: string;
  street2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  phones: CAPhoneObj[];
}

export class CAGraphics {
  // section 2: graphics
  logo: string;
  photo: string;
  primarycolor: string;
  secondarycolor: string;
  font?: string;
  smalllogo?: string;
  bodystyle?: string;
}

export class CALinks {
  // section 3: link
  url: string;
  googleplus: string;
  pinterest: string;
  snapchat: string;
  facebook: string;
  twitter: string;
  instagram: string;
  linkedin: string;
  wikilink: string;
  tumblr: string;
  youtube: string;
}

export class CAGeo {
  // section 4: geo
  county: string;
  long: number;
  lat: number;
  timezone: string; // this should be a pick list
  servicearea: CAServiceArea;
  backcolor?: string;
  selcolor?: string;

  east?: number;
  west?: number;
  north?: number;
  south?: number;
}

export class CAServiceArea {
  countries: string;
  states: string;
  counties: string;
  cities: string;
}

export class CADemographics {
  description: string;
  wikilink: string;
  female: number;
  male: number;
  type: string;
}

export class CARESSettings {
  projectbackgroundcolor: string;

  breadcrumbfont: string;


  bodywidth: number;
  font: string;
  menufont: string;
  menutextcolor: string;
  menuhovercolor: string;
  menutitle: LangStringBlock;
  menugroupbackgroundcolor: string;
  menugrouptextcolor: string;
  menustyle: string;
  menuwidth: number;

  menubackgroundcolor: string;

  languageon: boolean;
  languages: string; // these should be packed and unpacked into an array
  gridsettings: string;
  usebreadcrumb: boolean;
  breadcrumbstartname: LangStringBlock;
  breadcrumbstarturl: string;
  breadcrumbcolor: string;
  breadcrumbbackgroundcolor: string;
  breadcrumbexit: string;
  breadcrumbdelim: string;
  breadcrumbstyle: string;

  elementwidth: number;
  invfont: string;
  invpadding: number;
  invbackgroundcolor: string;
  invtextcolor: string;

}


export class Menu {
  ukey: string;
  nameDesc: LangStringBlock;
  pos: number;
  icon: string;
  langDesc: LangStringBlock;
  learnDesc: LangStringBlock;
  jsonld: string;   // todo: need to implement this when page is saved
  photo: string;
  rowidget: string;
  title: string;
  submenu: boolean;
  group: boolean;
  breadcrumb: BreadCrumb[];
  thirdcol?: number;
  heit?: number;
  centergrid?: number;
  lastsaved?: number;
  lasttrans?: number;

}


// 1. user creates a profile

// 1. comm creates a person

// 1. QUESTION: how link them?

// Community/orgukey/staff/personukey

// People/personukey/comperson/job/orguuid

// what happens when org deletes a person?
//-> ask if left. if did leave ask a reason for leaving and date?
// in any


/*
export class ComStaff {
    personukey: string;
    approved: boolean;
    fullname: string;
    title: string;
}
*/

export class Role {
  scope: string;
  service: string;
  population: string;
  focus: string;
  name: string;
  description: string;
  URL: string;
}

/*
export class Staff {
    personuuid: string;
    status: string;
    fullname: string;
    title: string;
}
*/

// this should really be called LegacyColleges since its for the legacy work
// and should be deleted once we switch over to the new RO
export class TmpColleges {
  collegeID: number;  // kwab's id
  collegeName: string; // kwab's name
  collegeNickname: string; // kwab's nickname
  cappCollegeId: string; // kwab's cappCollegeId;
  homepageType: string;
  sponsored: boolean;
  sponsorText: string;
  sponsorURL: string;
  primaryColor: string;
  secondaryColor: string;
  logofile: string;
  cityName: string;
  stateName: string;
  collegeNameLowerCase: string; // kwab's nameLowerCase
  consoleUkey: string; // ukey for college into new console
  roEditions: any;    //  -- [{roEditionID, roEditionName}, {} ...]
}

export class NotificationList {
  ukey: string;
}

export class NotificationListItem {
  ukey: string;
  fullname: string;
  notify: boolean;
  email: string;
  phone: string;
}

export class JobList extends NotificationListItem {
  individual: string; // this is the key
  present: boolean;
  roeintervention?: boolean;
  status: string; // Approved -Not Approved
  approvedbydate?: string; // todo: add a little icon that indicates that an employee has been approved
  approvedbywho?: string; // todo: add a little icon that indicates that an employee has been approved
  pos?: number;
}


export class Reporter {
  First: string;
  Last: string;
  College: string;
  Count: number;
  Company: string;
  Email: string;
}

export class LegacyCatalog {
  college_id?: number;
  description: string;
  long_description: string;
  icon_file: string;
  id: number;
  name: string;
  slug: string;
  map: LegacyMap[];
}

export class LegacyMap {
  id: number;
  type: string;
}

export interface HostDeviceInfo {
  device_os?: string;
  device_id?: number;
  api_auth_key?: string;
  api_root_endpoint?: string;
  default_college_name?: string;
  default_college_id?: number;
}

export interface HostContentInfo {
  type?: string;
  data?: number;
}

export interface HostMessage {
  request: string;
  data?: any;
  key?: string;
}

export class ROAppRes {
  id: number;
  active: boolean;
  name: string;
  slug: string;
  version: string;
  type: string;
  content: string;
  link: string;
  configData: string;
  object: string;
}

export class ArchiveList {
  ukey: string;
  name: string;
  dateofpub: string;
  summary: string;
  datearchived: string;
  CapptivationURL: string;
  filename: string;
  folder: string;
}

export class RFC {
  public name: string;
  public contact: string;
  public org: string;
  public from: string;
  public id: number;
  public dateMade: string;
  public rfctoresourceid: string;
  public rfctoreporterid: string;
  public request: boolean;
  public email: string;
  public instructions: string;
  public reportername: string;
  public reporteremail: string;
  public reporterphone: string;
  public flagged: boolean;
  public ukey: string;
}


///////////////////////
// LMS Interfaces
export const CourseStatus = [
  'All',
  'New',
  'Registered',
  'Completed',
  'Not Completed'
];

export class Student {
  name: string;
  phone: string;
  email: string;
  status: string;
  statusdate: string;
  ukey: string;
}

export class LMSNotification {
  subject: string;
  date: string;
  towhom: string;
  how: number;
  body: string;
  ukey: string;
  from: string;
}

// End LMS Interfaces
///////////////////////


///////////////////////
// ROB interfaces
export class RobHost {
  name: string;
  phone: string;
  email: string;
  organization: string;
  title: string;
  notes: string;
  ukey: string;
}


// End ROB Interfaces
//////////////////////

///////////////////////
// Incident interfaces
export const Relationship = [
  'Student',
  'Teacher',
  'Staff',
  'Other'
];

export class IncidentRpt {
  id?: string;
  dateincident: string;    // date of incident
  time: string;
  address: string;
  gender: string;  // Gemnders
  age: string;     // Ages
  race: string;    // Races
  preference: string; // Preferences
  disability: string; // Disabilities
  experience: string;
  dateservice: string; // date service provided
  service: string;
  reportedtoschool: boolean;
  reportedtopolice: boolean;
  long: number;
  lat: number;
  ukey: string;
}

export class StatRpt {
  org: string;
  rpt: IncidentRpt;
  ukey: string;
}

export class Template {
  name: LangStringBlock;
  desc: LangStringBlock;
  ukey: string;

  constructor() {
    this.name = new LangStringBlock();
    this.desc = new LangStringBlock();
  }
}

export class MapTemplate {
  json: string;
  ukey: string;
}

export class NewsTemplate {
  publisher: string;  // name of the publisher
  publisherurl: string; // publisher's website
  publogopath: string;
  publogo: StyleTemplate; // formatting of publisher's logo in an article-card
  author: StyleTemplate;
  date: StyleTemplate;
  copyright: StyleTemplate;
  category: StyleTemplate;
  ukey: string;


  constructor(ukey) {
    this.ukey = ukey;
    this.author = new StyleTemplate();
    this.date = new StyleTemplate();
    this.copyright = new StyleTemplate();
    this.category = new StyleTemplate();
    this.publogo = new StyleTemplate(40);

  }
}

export class StyleTemplate {
  fontfamily: string;
  fontsize: string;
  bold: boolean;
  italics: boolean;
  color: string;
  alignment: string;
  height: number;
  backgroundcolor: string;

  constructor(height?: number) {
    if (height) {
      this.height = height;
    }
    this.fontfamily = 'Roboto';
    this.fontsize = '16px';
    this.bold = false;
    this.italics = false;
    this.color = '#000000';
    this.backgroundcolor = '#FFFFFF';
    this.alignment = 'left';
  }
}

export class GalleryItem {
  asset: Asset;
  cols: number;
  rows: number;

  constructor() {
    this.cols = 1;
    this.rows = 1;
  }
}

export class ShowBits {
  gallery: boolean;
  map: boolean;
  timeline: boolean;
  behind: boolean;
  breadcrumb: boolean;

  constructor() {
    this.gallery = false;
    this.map = false;
    this.timeline = false;
    this.behind = false;
    this.breadcrumb = false;
  }
}

export class Content {
  ukey: string;
  type: string; // BreadCrumbs, TimeLine, Gallery, Map, Article
  date: number; // date created
  public: boolean; // true means the content is added to the public directory (algolia) and be searched for.
  topic: boolean; // true means people can subscribe to it.
  settings: Topix;
  collaborators: Topix[]; // every collaborator must use a Topix because that Topix references the author

  constructor(org: string) {
    this.settings = new Topix(org); // this is the nugget stored in Algolia
  }
}

export class ContentBody {
  versions: ContentVersion[];  // this is where the drafts/versions are stored
  notifications: string[]; // an array of notification ukeys. typically send a notification when there is a change
  linkedto: string[]; // what news content-edit, full path to things that reference it that reference it
  notes: Note[];
  ukey: string;

  constructor(ukey) {
    this.versions = [];
    this.notifications = [];
    this.linkedto = [];
    this.notes = [];
    this.ukey = ukey;
  }

}


export class ContentVersion {
  meta: ContentMeta; // every version has to have meta data: when saved, how edited, note: what was changed,
  body; // this is where the version content will go - the type will depend on the type of content
  edityby: string; // name of the person who made the edits
  cards; // this is an array of objects attached to the version for example one or more Galleries, Maps, Breadcrumbs, other content-edit, profiles, polls
  date: number; // date saved used as the ukey

  constructor(type) {
    this.meta = new ContentMeta();
    this.meta.type = type;
  }
}

export class ContentMeta {
  type: string;
  note: string; // descrition of what whas changed
  tags: string;
  targets: string; // this is a comma deliminated string of the demo targeted by the writer/publisher
  open: boolean; // if true then anyone can read the article; if false then the rules of the Topic determine ability to read.
  archived: boolean;

  constructor() {
    this.open = true;
    this.archived = false;
  }

}

export class ExGallery {
  items: GalleryItem[];
  name: string;
  ukey: string;
  rowHeight: number;
  cols: number;
  authors: Topix[];

  constructor() {
    this.rowHeight = 100;
    this.cols = 4;
    this.items = [];
  }
}

export class ContentMap {
  ukey: string;
  center: MapItem;
  mapitems: MapItem[];
  routes: MapItem[];
  type: string; // 'Places', 'Local', 'Travel', 'Time Series', 'Resource'
  zoom: number;
  template: MapTemplate;
  authors: Topix[];
  counts: TopixCounts;

  constructor() {
    this.type = 'Places';
    this.mapitems = [];
    this.routes = [];
    this.authors = [];
    this.zoom = 12;
    this.counts = new TopixCounts();
  }
}


export class NewsArticle {
  ukey: string;

  body: LangStringBlock;
  headline: LangStringBlock;
  subheadline: LangStringBlock;
  msgphotos: Asset[];
  authors: Topix[];
  template: NewsTemplate;
  articleurl: string; // url of the article on the publisher's web site;
  category: string;
  copyright: string;
  publication: string;

  show: ShowBits;
  counts: TopixCounts;
  pubdate: number;
  date: number; // this is like the ukey in that it's the date that the article was saved


  constructor() {
    this.body = new LangStringBlock();
    this.headline = new LangStringBlock();
    this.subheadline = new LangStringBlock();
    this.counts = new TopixCounts();
    this.msgphotos = [];
    this.authors = [];
    this.show = new ShowBits();
  }
}

export class ObjName {
  type: string; // person, place, dog, cat
  fullname: string; //
  alias: string; // name of Obj as used in a specific case
  indivukey: string;
  photo: string;
  ukey: string;
}

export class GooglePhoto {
  who: string;
  url: string;
  caption: string;
}

export class Star {
  stars: number;
  indivukey: string; // who made the star
  profilepic: string; // face of the comment
  date: number; // when did the evaluation get made
}

export class Wish extends MapItem {
  start: number;
  recipe: any;
  completed: boolean;  // if the wish is a BlogGuide then completed = true means that the trip ends where it started for purposes of the map
  dayzero: number; // start of the day
  distance: string;
  visitdate: number;
  climate: any;
  paid: boolean;
  type: string; // e.g. header, dateheader, formentry, travel - for a Guide, type can equal itinerary or travelogue
  loc: string;
  photos: GooglePhoto[];
  trip: any;  // this stores and array of Wishes when creating a Travel Guide
  products: any; // a place for produt placements or book placements that we either sell in our marketplace or via affiliate
  vendors: any; // list of vendors mentions in a guide
  artists: any;
  festivals: any;
  routes: any;
  pops: any;
  mentions: any;
  events: Wish[];
  icon: string;
  address_components: any;
  website: string;
  formatted_phone_number: string;
  formatted_address: string;
  url: string;
  types: string[];  // could store tags here so for example, i could know that a Wish is a Restaurant
  attribs: any[];
  review: any;
  departure: string; //   eg flight number, boat number, train
  arrival: string;
  budget: any;
  notes: Note[];
  stars: Star[];
  guides: Wish[];
  avgstars: number;
  blogs: string[]; // ukeys of postcards
  plus_code: any;
  utc_offset: number;
  price_level: number;
  // place_id: string;
  yelp;
  wikiurl: string;
  wishkey: string;
  keys: Key[];

  constructor(indivukey: string, companions: Topix[]) {
    super(indivukey, companions);
    this.app = 'Adventures';
    this.keys = [];
    this.attribs = [];
    this.types = [];
  }

}


export class Location {
  location: string; // this is either a name or an address
  long: number;
  lat: number;
  country: string;
  countrycode: string;
  hash: string;
  address: string; // this is an address
  utc_offset_minutes: number;
  tzone: string;
  tzoneobject: {};
  loc: string;
  viewport: any;
  bounds: any;

}

export class Key {
  name: string;
  id: string;
}

export class GuideMap {
  style: string;
  returntostart: boolean;

  constructor() {
    this.returntostart = false;
  }
}

export class PlaceLoc extends Location {
  keys: Key[];
  name: string;

  // needed for mapbox flyto for BlogGuides Intinerary
  bearing: 90;
  // center: [-0.08533793, 51.50438536],
  zoom: number; // 13,
  speed: number; // 0.6,
  pitch: number; // 40

  constructor() {
    super();
    this.keys = [];
    this.bearing = 90;
    // center: [-0.08533793, 51.50438536],
    this.zoom = 13;
    this.speed = 0.6;
    this.pitch = 40;
  }
}


export class Privacy {
  code: string; // Personal, Companions, Friends, Followers, Public
                // If public then link to the photo is stored in two places: PlacesHash and Places
                // and store a record of the entire transaction in a publicPhotos cloud function
  indivukeys: string;
}

export class Tag {
  name: string;
  indivukey: string;
  type: string; // person, place, thing, blank = a person who doesn't have a indivukey
  box: Box;

  constructor() {
    this.box = new Box();
  }
}

export class Box {
  x: number;
  y: number;
  w: number;
  h: number;
}

export class CovidData {
  status: string;
  date: number;
}

// todo: this could be expanded to allow for each to have an array of values
export class ContactDetails {
  phones: PhoneObj[];
  emails: PhoneObj[];
  addresses: Address[];
  org: string;
  title: string;
  bdate: number;

  constructor() {
    this.phones = [];
    this.emails = [];
    this.org = '';
    this.title = '';
  }

}

export class Model {
  url: string;
  path: string;
  ukey: string;
  assetukey: string;
}

// this data structure is needed because the same person could be on multiple cappteams
export class CappRelationship {
  cappukey: string; // ukey to the cappteam
  cappname: string;
  status: string; // gray means you've invited them, blue means they've invited u, green means offer accepted;
}

export class CappPermissions {
  exhibits: number; // -1 = can't view, 0 = view public exhibits, 1 = view all exhibits, 2 = view personal exhibits
  phone: boolean;
  email: boolean;
  addresses: boolean;
  username: boolean;
  loc: boolean;
  locon: boolean; // this is true WHEN a user has turned location tracking on.

  constructor() {
    this.exhibits = 0; // -1 = can't view, 0 = view public exhibits, 1 = view all exhibits, 2 = view personal exhibits
    this.phone = true;
    this.email = true;
    this.addresses = true;
    this.username = true;
    this.loc = false;
    this.locon = false;
  }

}

export class Fav {
  name: string;
  path: string; // this is the full path to resource;
  indivukey: string; // when a person has first been selected from the addressbook then this won't have a value
  contact: ContactDetails;
  friend: string; // gray means you've invited them, blue means they've invited u, green means offer accepted;
  helper: string; // used for bystander intervention - gray means you've invited them, blue means they've invited u, green means offer accepted;
  capps: CappRelationship[]; // gray means you've invited them, blue means they've invited u, green means offer accepted; pink means just a friend
  covid: string; // gray means you've invited them, blue means they've invited u, green means offer accepted;
  contactlists: string; // comma delimited list of contactlist ukeys
  coviddata: CovidData;
  quarantine?: CovidQuarantine;
  covidfor: string; // this is the indivukey of the dependent with whom the fav has the relationship
  status: boolean;
  ukey: string;
  models: Model[];
  blocked: any;
  photo: string;
  color: string;
  proxy?: boolean; // true if the contact is not in system
  notes: Note[];
  username: string;
  perms: CappPermissions;  // these are the permissions being assigned to a friend
  userperms: CappPermissions; // these are teh mermissions that have been assigned to a friend
  genrel: string; // genetic relationship: family, etc. this will be expanded later for 6 degress of separation
  socialrel: string; //
  bizrel: string;

  constructor() {
    this.perms = new CappPermissions();
    this.contact = new ContactDetails();
    this.userperms = new CappPermissions();
  }

}

export class Bucket {
  name: LangStringBlock;
  path: string;
  type: string; // wish, postcard
  ukey: string;

  constructor() {
    this.name = new LangStringBlock();
  }
}


export class ItineraryDetails {
  poly: any;
  day: number; // what day of the trip will this fall on
  activitynumber: number;
  // todo: maybe store the path to a desitation
  distanceto: number; // distance to next activity in kilomters
  durationto: number; // time to next activity in minutes
  elevationgainto: number; // meters
  goingto: PlaceLoc;
  mode: string; // mode of transporation to next activity: walking, train, etc, various
  constructor() {
    this.goingto = new PlaceLoc();
  }
}

// todo: save if public view to Assets in the Asset/${ukey}
// todo: sure would be nice to be able to track usage in someplace AssetUse
// todo: eventually this would be in the full text search database like Algolia
export class Asset {
  url: string;
  name: LangStringBlock;
  description: LangStringBlock;
  alt: LangStringBlock; // for ADA compliance
  type: string; // image, video, pdf, document, text, asset
  filename: string;
  thumb?: string;
  ukey: string;

  expname: string;
  expukey: string;
  parties: string; // this is the list of the individuals at the event - they are not necessarily in the photo.
  tags: Tag[];  // todo V2: implement with face recognition

  date: number;     // date asset was archived
  pubdate: number;  // date assets was created
  creators: ObjName[]; // name of creators
  iukeys: string; // comma deliminated list of indivukeys that are used for replicating the assets to Individual/${}/assets
  location: PlaceLoc;  // todo: writing a location should trigger a cloud function that allows for the asset to be identified using a geo hash
  finlocation: PlaceLoc;
  copyright?: string;
  buckets: Bucket[]; // paths to who is using the assets
  objects: ObjName[];  // list of people or things in or associated with the Asset
  assets: Asset[]; // for example, a map has assets that are locations and associated with each location could be an array of photos
  privacy: Privacy;
  use: string; // for example MIT License or maybe there is a cost to it
  id: string; // the id assigned to an asset by a third party
  fav: boolean; // u can favorite an asset for easy viewing; when an asset is in a postcard, true means display
  cancopy: boolean; // if true than a non creator can make a copy of the asset

  constructor(indivukey: string, name: string, profilepic: string) {
    this.description = new LangStringBlock();
    this.alt = new LangStringBlock();
    this.name = new LangStringBlock();
    this.privacy = new Privacy();
    this.privacy.code = 'Followers';
    this.type = 'photo'; // default case
    this.privacy.indivukeys = indivukey;
    this.location = new PlaceLoc();
    this.finlocation = new PlaceLoc();
    this.objects = [];
    this.creators = [];
    this.buckets = [];
    this.date = new Date().getTime();
    this.creators = [];
    this.fav = false;
    this.cancopy = true; // todo: not sure if this should be false or true????
    const creator = new ObjName();
    creator.type = 'person'; // person, place, dog, cat
    creator.fullname = name; //
    creator.alias = ''; // name of Obj as used in a specific case
    creator.indivukey = indivukey;
    creator.photo = profilepic;
    this.creators.push(creator);
  }
}

// todo: get rid of this ASAP
export class Assets {
  url: string;
  filename: string;
  xsize?: number;
  ysize?: number;
  description: LangString;
  ukey: string;
  date: string;     // date asset was archived
  pubdate: number;  // date assets was created
  creator: string; // at first just a name, but later it will be a ukey to the creator
  folder: string;
  thumb?: string;
  alt: LangString;
  location?: string;
  lat?: number;
  long?: number;
  copyright?: string;
  type: string; // image, video, pdf, document

  constructor() {
    this.description = new LangString();
    this.alt = new LangString();
  }
}


export class PartnerRequest {
  date: string;
  name: string;
  email: string;
  org: string;
  path: string;
  theirpath: string;
  ukey: string;
  status: string;
  who: string;
  subcalendar: boolean; // true if want to subscribe to their calendar
}

export class LinkHolder {
  link: string;
  partner: boolean;
}

export class PartnerContact {
  name: string;
  path: string;
  org: string;
  note: string;
  ukey: string;
}

export class DisplayContact {
  name: string;
  title: string;
  email: string;
  phones: PhoneObj[];
  note: string;
}

export class IncidentComOrg {
  community: string;
  org: string;
  date: string;
  incidenttype: string;
  ukey: string;
}

export class IncidentForm {
  confidentiality?: boolean;
  date: string;
  clientname?: string;
  clientemail?: string;
  clientphone?: string;
  clientrelationship?: string;
  incidentlocation?: string;
  incidentdateandtime?: string;
  incidenttype: string;
  serviceperformed?: string;
  othersinformed?: string;
  notes?: string;
  status: string;
  ukey: string;
}

// End of Incident interfaces
/////////////////////////////


export class GuideContact {
  name: string;
  email: string;
  ukey: string;
  org: string;
  url: string;
}


@Injectable({
  providedIn: 'root'
})
export class InterfaceService implements OnDestroy {
  curComOrg: ComOrg;
  cappguides;
  contacts: JobList[];
  guidecontact: GuideContact;
  $sub1;
  devicePlatform: string;
  topixs: Topix[];
  filters: string[];
  eds: OrgEdition[];
  surveys: CappSurveyForm[];
  genericsurveys: CappSurveyForm[];
  gl: GuideList[];
  rl: CappReportForm[];


  constructor(public snackBar: MatSnackBar,
              public authx: AngularFireAuth,
              private http: HttpClient,
              private db: AngularFireDatabase,
              private bottomSheet: MatBottomSheet,
              private dbRef: AngularFirestore,
              private admin: AdminService,
              private bz: BizhoursService,
              private fs: FirebaseService) {
  }

  /*
    getTrans() {
      this.is.getObject(`ROEDevices/${this.deviceId}/curlang`)
        .take(1)
        .subscribe(b => {
          if (b) {
            this.curlang = b;
          }

          this.is.getObject(`Trans/CARES/${this.curlang}`).take(1).subscribe(trans => {
            this.t = trans;
            this.controltitle = this.t['notifications'];
          });

          this.is.getObject(`TransCon/Capp/${this.curlang}`).take(1).subscribe(trans => {
            this.c = trans;
          });

          this.is.getObject(`TransLang/CARES`).take(1).subscribe(tblock => {
            this.tblock = tblock;
          });

        });
    }
  */


  onPulse(event, id) {
    event.stopPropagation();
    const backcolor = '#FFFFFF';

    let str;
    this.getObject(`TransHelp/${id}/${this.admin.curlang}/description`).take(1).subscribe(trans => {
      if (trans) {
        str = trans;
      } else {
        str = 'Not available: ' + id; // 'Sorry, there is no information for this option.';
      }
      this.bottomSheet.open(HelpBottomComponent,
        {data: {str, backcolor, primarycolor: '#000000'}});
    });


  }

  /*
      const dbRef = this.afs.collection('Community');
      const pushkey = 'university'
      const project = {ukey: pushkey, profile: 'small test'};
      dbRef.doc(pushkey).set(project);

   */


  nextCom(nxt?) {

    /*
            if (nxt) {
                this.getQueryStart('Community', nxt).take(1).subscribe(val => {
                    this.admin.nextcom = val[1].ukey;
                })
            } else {
                this.getObject('NextCom').take(1).subscribe(next => {
                    this.getQueryStart('Community', next).take(1).subscribe(val => {
                        this.admin.nextcom = val[1].ukey;
                        console.log('next', this.admin.nextcom)
                    })
                })
            }
    */

  }

  getOrgReportList() {
    this.getList(`Orgs/${this.admin.admin.org}/reports`).take(1).subscribe(rl => {
      this.rl = rl;
    });
  }

  getOrgGuideList() {
    this.getList(`Orgs/${this.admin.admin.org}/guideslist`).take(1).subscribe(gl => {
      this.gl = gl;
    });
  }


  getOrgSurveys(loc: string) {
    this.getList(`${loc}/${this.admin.admin.org}/surveys`).take(1).subscribe(s => {
      this.surveys = s;
    });
    this.getList(`${loc}/${this.admin.admin.org}/genericsurveys`).take(1).subscribe(s => {
      this.genericsurveys = s;
    });
  }

  getTopics(loc) {
    this.getList(`${loc}Pri/${this.admin.admin.org}/topics`).take(1).subscribe(topics => {
      if (topics && topics.length > 0) {
        this.topixs = topics;
      }
    });
  }

  getFilters() {
    this.filters = [];
    this.getList(`Orgs/${this.admin.admin.org}/filters`).take(1).subscribe(filters => {
      if (filters && filters.length > 0) {
        this.filters = filters;
      }
    });
  }

  getTrans() {
    // todo: needs to be changed
    this.getObject(`Trans/CARES/${this.admin.curlang}`).take(1).subscribe(trans => {
      this.admin.t = trans;
    });
    this.getObject(`Trans/ROC/${this.admin.curlang}`).take(1).subscribe(trans => {
      this.admin.roct = trans;
    });
  }

  getCappGuides() {
    this.cappguides = [];
    if (this.curComOrg && this.curComOrg.emailextentions) {
      this.getQuery(`ROEInterventions`, 'domain', this.curComOrg.emailextentions).take(1).subscribe(cgs => {
        this.cappguides = cgs;
        console.log('this.cappguides', this.cappguides);
      });
    }
  }

  getContacts(ukey) {
    this.getObject(`GuideContact/${ukey}`).take(1).subscribe(contact => {
      this.guidecontact = contact;
    });

    this.contacts = [];
    if (!this.admin.staff) {
      this.$sub1 = this.getList(`Lists/${this.admin.admin.org}/jobs`).subscribe(list => {
        if (list && list.length > 0) {
          this.admin.staff = list;
          console.log('list', list);
          if (list && list.length > 0) {
            this.contacts = [];
            let cnt = 0;
            list.forEach(l => {
              console.log('present', `Individual/${l.ukey}/jobs/${this.admin.admin.org}/present`);

              const url = 'https://us-central1-library-titleix.cloudfunctions.net/postROECheckPresent';

              this.authx.auth.currentUser.getIdToken().then(authToken => {
                const headersv = new HttpHeaders({Authorization: 'Bearer ' + authToken});
                return this.http.post(url,
                  {
                    path: `Individual/${l.ukey}/jobs/${this.admin.admin.org}/present`,
                  },
                  {headers: headersv}).toPromise();
              })
                .then(res => {
                  console.log(res);
                  cnt = cnt + 1;
                  if (res['present']) {
                    this.contacts.push(l);
                  }
                  if (cnt === list.length && this.contacts.length > 0) {
                    this.contacts = _.orderBy(this.contacts, ['pos'], ['asc']);
                    console.log('contacts', this.contacts);
                  }
                });
            });
          }
        }
      });
    } else {
      if (this.admin.staff && this.admin.staff.length > 0) {
        this.contacts = this.admin.staff.filter(s => s.present);
        if (this.contacts && this.contacts.length > 0) {
          this.contacts = _.orderBy(this.contacts, ['pos'], ['asc']);
        }
      }
    }
  }

  onSelectOrg(ukey, tmpOrg) {
    this.admin.admin.org = ukey;
    this.admin.admin.modules = new Array();
    this.admin.commodules.forEach(v => {
      v.value = true;
      const tmp = new Module();
      tmp.val = true;
      tmp.name = v.name;
      this.admin.admin.modules.push(tmp);
    });

    this.admin.admin.type = 'Admin';
    this.curComOrg = tmpOrg;
    this.contacts = null;
    this.getCappGuides();
    this.admin.languageon = true;
    this.admin.language = 'en';
    this.admin.fulllanguage = 'English';

  }


  getBehaviorList(start: BehaviorSubject<string>,
                  end: BehaviorSubject<string>,
                  path): Observable<any[]> {
    return Observable.zip(start, end).switchMap(param => {
      return this.fs.titleIXdb.list(path, ref =>
        ref
          .orderByChild('ukey')
          .limitToFirst(20)
          .startAt(param[0])
          .endAt(param[1])
      )
        .snapshotChanges()
        .map(changes => {
          return changes.map(c => {
            return {ukey: c.payload.key, ...c.payload.val()};
          });
        });
    });
  }


  getSchoolList(pth): Observable<any[]> {
    return this.fs.schooldb.list<any>(pth).valueChanges();
  }

  getSchoolObject(pth): Observable<any> {
    return this.fs.schooldb.object(pth).valueChanges();
  }

  getQueryStartEnd(pth, start, end): Observable<any[]> {
    return this.fs.titleIXdb.list(pth,
      ref => ref.orderByKey()
        .startAt(start)
        .endAt(end))
      .valueChanges();
  }

  // .startAt(key).
  getQueryStart(pth, key, limit): Observable<any[]> {
    console.log('key', key, limit);
    return this.fs.titleIXdb.list(pth,
      ref => ref.orderByKey().limitToFirst(limit))
      .valueChanges();
  }

  getQuery(pth, child, key): Observable<any[]> {
    return this.fs.titleIXdb.list(pth,
      ref => ref.orderByChild(child).equalTo(key))
      .valueChanges();
  }

  getListWithIds(pth): Observable<any[]> {
    return this.fs.titleIXdb.list(pth)
      .snapshotChanges()
      .map(changes => {
        return changes.map(c => {
          return {ukey: c.payload.key, ...c.payload.val()};
        });
      });
  }

  getListWithUkeys(pth): Observable<any[]> {
    return this.fs.titleIXdb.list(pth)
      .snapshotChanges()
      .map(changes => {
        return changes.map(c => {
          return {ukey: c.payload.key, val: c.payload.val()};
        });
      });
  }

  getList(pth): Observable<any[]> {
    return this.fs.titleIXdb.list<any>(pth).valueChanges();
  }

  getLimitToLastoOne(path): Observable<any[]> {
    return this.fs.titleIXdb.list(path, ref =>
      ref
        .orderByChild('ukey')
        .limitToLast(1)
    ).valueChanges();
  }

  getFirst(path, n): Observable<any[]> {
    return this.fs.titleIXdb.list(path, ref =>
      ref
        .limitToFirst(n)
    ).valueChanges();
  }


  getFirstSnapN(path, n): Observable<any[]> {
    return this.fs.titleIXdb.list(path, ref =>
      ref.orderByChild('ukey')
        .limitToFirst(n)
    ).snapshotChanges()
      .map(changes => {
        return changes.map(c => {
          return {ukey: c.payload.key, val: c.payload.val()};
        });
      });
  }

  getFirstSnapNKeys(n, path, startkey): Observable<any[]> {
    return this.fs.titleIXdb.list(path, ref =>
      ref.orderByKey()
        .startAt(startkey)
        .limitToFirst(n)
    ).snapshotChanges()
      .map(changes => {
        return changes.map(c => {
          return {ux: c.payload.key, val: c.payload.val()};
        });
      });
  }


  getFirstSnapKeys(n, path, startkey): Observable<any[]> {
    return this.fs.titleIXdb.list(path, ref =>
      ref
        .orderByKey()
        .startAt(startkey)
        .limitToFirst(n)
    ).snapshotChanges()
      .map(changes => {
        return changes.map(c => {
          return c.payload.key;
        });
      });
  }

  getLimitToNextnKeys(n, path, startkey): Observable<any[]> {
    return this.fs.titleIXdb.list(path, ref =>
      ref
        .orderByKey()
        .startAt(startkey)
        .limitToFirst(n)
    ).valueChanges();
  }



  getLast15(path): Observable<any[]> {
    return this.fs.titleIXdb.list(path, ref =>
      ref
        .orderByChild('ukey')
        .limitToLast(15)
    ).valueChanges();
  }



  getLastn(path, n): Observable<any[]> {
    return this.fs.titleIXdb.list(path, ref =>
      ref.limitToLast(n)
    ).snapshotChanges()
      .map(changes => {
        return changes.map(c => {
          return {date: c.payload.key, val: c.payload.val()};
        });
      });
  }


  getObjectFS(pth): Observable<any> {
    return this.dbRef.doc(pth).valueChanges();
  }

  getObject(pth): Observable<any> {
    return this.fs.titleIXdb.object(pth).valueChanges();
  }

  getFirstSnap(path): Observable<any> {
    console.log('path', path)
    return this.fs.titleIXdb.object(path).snapshotChanges()
      .map(c => {
        const obj = c.payload.val();
        console.log('obj', obj)
        obj['key'] = c.payload.key;
        console.log('payloadkey', c.payload.key)
        return obj;
      });
  }



  deleteSchoolObj(pth, type, detail) {
    this.fs.schooldb.object(pth).remove();
    this.createOrgLog(pth, `Delete`, type, detail);
  }


  deleteObjFS(pth, type, detail) {
    this.dbRef.doc(pth).delete();
    this.createOrgLog(pth, `Delete`, type, detail);
  }

  deleteObj(pth, type, detail) {
    this.fs.titleIXdb.object(pth).remove();
    this.createOrgLog(pth, `Delete`, type, detail);
  }

  deleteObjNoLog(pth) {
    this.fs.titleIXdb.object(pth).remove();
  }

  deleteObjPromise(pth, type, detail): Promise<any> {
    this.createOrgLog(pth, `Delete`, type, detail);
    return this.fs.titleIXdb.object(pth).remove();
  }


  deleteResourceObj(org, pth, ukey, kwabid, type, detail) {
    this.createOrgLog(pth, `Delete`, type, detail);

    this.fs.titleIXdb.object(`Orgs/${org}/resources/list/${ukey}`).remove()
      .then(i => {
        this.fs.titleIXdb.object(pth).remove();
      })
      .catch();
    this.fs.titleIXdb.object(`LegacyLookup/${kwabid}`).remove();

  }

  createOrgLog(url, action, type, detail) {
    if (!url.includes('Legacy')) {

      /*
                  const arr = url.split('/')[1];
                  let s = '';
                  if (arr[0] === 'Orgs' || arr[0] === 'Community') {
                      s = arr[1];
                  } else {
                      s = arr[0];
                  }
      */
      const orglog = new OrgLog();
      orglog.ukey = this.fs.titleIXdb.createPushId();
      orglog.source = 'Console';
      orglog.action = action;
      orglog.type = type;
      orglog.detail = detail;

      // todo: i messed this up when i did the upgrade to no
      orglog.inputer = this.admin.admin.name;
      if (this.admin.admin.sponsor) {
        orglog.sponsor = this.admin.admin.sponsor;
      } else {
        orglog.inputerorg = this.admin.admin.org;
      }
      orglog.date = new Date().toISOString();

      this.fs.titleIXdb.object(`Logs/${this.admin.admin.org}/${orglog.ukey}`).set(orglog);
    }
  }


  setSchoolObj(pth, obj) {
    this.fs.schooldb.object(pth).set(obj)
      .then(res => {
        this.snackBar.open('Data saved', '', {
          duration: 1000,
        });
      })
      .catch(err => {
        this.snackBar.open('Error:', err, {
          duration: 1000,
        });
      });
  }

  pushObj(pth, obj) {
    const lst = this.fs.titleIXdb.list(pth);
    lst.push(obj);
  }

  setObjNoSnack(pth, obj) {
    this.fs.titleIXdb.object(pth).set(obj);
  }

  setObjNoLog(pth, obj) {
    this.fs.titleIXdb.object(pth).set(obj)
      .then(res => {
        /*
                this.snackBar.open('Data saved', '', {
                  duration: 1000,
                });
        */
      })
      .catch(err => {
        this.snackBar.open('Error:', err, {
          duration: 1000,
        });
      });
  }

  updateObjNoLog(pth, obj) {
    this.fs.titleIXdb.object(pth).update(obj);
  }

  setFieldFS(pth, field, obj) {
    this.dbRef.doc(pth).update({[field]: obj});
  }

  setObjFS(pth, obj) {
    this.dbRef.doc(pth).set(JSON.parse(JSON.stringify(obj)))
      .then(res => {
        this.snackBar.open('Data saved', '', {
          duration: 1000,
        });
      })
      .catch(err => {
        this.snackBar.open('Error:', err, {
          duration: 1000,
        });
      });
  }


  setObj(pth, obj, type, detail) {
    this.fs.titleIXdb.object(pth).set(obj)
      .then(res => {
        this.createOrgLog(pth, `Add/Edit`, type, detail);
        this.snackBar.open('Data saved', '', {
          duration: 1000,
        });
      })
      .catch(err => {
        this.snackBar.open('Error:', err, {
          duration: 1000,
        });
      });
  }

  setObjRemove(pth, obj, rmv, arr) {
    this.fs.titleIXdb.object(pth).set(obj)
      .then(res => {
        this.fs.titleIXdb.object(rmv).remove().then(v =>
          arr.forEach(j => {
            this.fs.titleIXdb.object(`${rmv}/${j.organization}`).set(j);
          }));
      })
      .catch(err => {
      });
  }

  setObjPromise(pth, obj, type, detail): Promise<any> {
    return this.fs.titleIXdb.object(pth).set(obj)
      .then(res => {
        this.createOrgLog(pth, `Add/Edit`, type, detail);
        this.snackBar.open('Data saved', '', {
          duration: 1000,
        });
      })
      .catch(err => {
        this.snackBar.open('Error:', err, {
          duration: 1000,
        });
      });
  }

  updateObj(pth, obj, type, detail) {
    this.fs.titleIXdb.object(pth).update(obj)
      .then(res => {
        this.createOrgLog(pth, `Add/Edit`, type, detail);
        this.snackBar.open('Data saved', '', {
          duration: 1000,
        });
      })
      .catch(err => {
        this.snackBar.open('Error:', err, {
          duration: 1000,
        });
      });
  }

  setResourceObject(org, pth, item, type, detail) {
    this.fs.titleIXdb.object(`Orgs/${org}/resources/list/${item.ukey}`).remove();
    this.createOrgLog(pth, `Add/Edit`, type, detail);

    this.fs.titleIXdb.object(pth).update(item)
      .then(data => {

        this.snackBar.open('Data saved', '', {
          duration: 1000,
        });
      })
      .catch(err => {
        this.snackBar.open('Error:', err, {
          duration: 1000,
        });
      });

    if (item.primaryservice) {
      this.fs.titleIXdb.object(`Orgs/${org}/resources/list/${item.ukey}`).set(item.primaryservice);
    }
  }

  setResourceObjectWithHours(org, pth, item, type, detail) {
    this.fs.titleIXdb.object(`Orgs/${org}/resources/list/${item.ukey}`).remove();
    this.createOrgLog(pth, `Add/Edit`, type, detail);

    this.fs.titleIXdb.object(pth).update(item)
      .then(data => {

        this.bz.savebuisinesshours(pth + '/hours', item.hours);

        this.snackBar.open('Data saved', '', {
          duration: 1000,
        });
      })
      .catch(err => {
        this.snackBar.open('Error:', err, {
          duration: 1000,
        });
      });

    if (item.primaryservice) {
      this.fs.titleIXdb.object(`Orgs/${org}/resources/list/${item.ukey}`).set(item.primaryservice);
    }
  }

  setObjectWithHours(pth, item, type, detail) {
    this.createOrgLog(pth, `Add/Edit`, type, detail);

    this.fs.titleIXdb.object(pth).update(item)
      .then(data => {

        console.log('best', item.hours);
        this.bz.savebuisinesshours(pth + '/hours', item.hours);

        this.snackBar.open('Data saved', '', {
          duration: 1000,
        });
      })
      .catch(err => {
        this.snackBar.open('Error:', err, {
          duration: 1000,
        });
      });
  }

  /*
      saveMapCategories(language, ukey, cats: MapCategory[], type, detail, mapukey) {
          this.createOrgLog(`Orgs/${ukey}/maps`, `Add/Edit`, type, detail);

          let i = 0;
          cats.forEach(mc => {
              mc.pos = i;
              this.fs.titleIXdb.object('Orgs/' + ukey + '/maps/' + mapukey + '/' + mc.nameDesc[language].description).set(mc);
              i = i + 1;
          });
      }
  */


  setArrayPos(path: string, tmp: any[], type, detail) {
    this.createOrgLog(path, `Add/Edit`, type, detail);

    this.fs.titleIXdb.object(path).remove().then(val => {
      let i = 0;
      tmp.forEach(mc => {
        this.fs.titleIXdb.object(path + '/' + mc.ukey).set(mc);
        i = i + 1;
      });
    });
  }

  // CA stuff
  getPromiseList(pth): Promise<any[]> {
    return this.db.list<any>(pth).valueChanges()
      .pipe(take(1))
      .toPromise();
  }

  getId() {
    return this.db.createPushId();
  }

  // end CA Stuff


  onSaveMd5(placeID, website, name, source = 'Auto') {
    if (website && website.length && placeID && placeID.length) {
      const web = website.toLowerCase()
      const md5var = md5(web);
      if (md5var && md5var.length > 6) {
        const md5obj = {
          url: web,
          ukey: md5var,
          placeID: placeID,
          name: name,
          source,
        };


        // source = Auto means that the website and the place_id were not verified that they belong together and
        // thus, at some point may need to be verified
        this.setObjNoLog(`Places/${placeID}/md5/${md5var}`, md5var);  // hash
        this.setObjNoLog(`PlacesMd5/${md5var}`, md5obj);  // hash
      }

      if (website.startsWith('http:')) {
        const newwebsite = website.replace('http:', 'https:')

        const newmd5var = md5(newwebsite);
        if (newmd5var && newmd5var.length > 6) {
          const md5obj = {
            url: newwebsite,
            ukey: newmd5var,
            placeID: placeID,
            name: name,
            source,
          };

          // source = Auto means that the website and the place_id were not verified that they belong together and
          // thus, at some point may need to be verified
          this.setObjNoLog(`Places/${placeID}/md5/${newmd5var}`, newmd5var);  // hash
          this.setObjNoLog(`PlacesMd5/${newmd5var}`, md5obj);  // hash
        }
      }




    }
  }

  onPlaceMd5(placeID, website, name, source = 'Auto') {

    // the find characters must be at the END of a string
    const cases = [
      {find: '/en', replace: '/'},
      {find: '/en/', replace: '/'},
      {find: '/fr', replace: '/'},
      {find: '/fr/', replace: '/'},
      {find: 'index.htm', replace: ''},
      {find: 'index.html', replace: ''},
      {find: 'index.aspx', replace: ''},
      {find: 'index.php', replace: ''},
      {find: 'index.htm/', replace: ''},
      {find: 'index.html/', replace: ''},
      {find: 'index.aspx/', replace: ''},
      {find: 'index.php/', replace: ''}];

    if (website && website.length && placeID && placeID.length) {
      this.onSaveMd5(placeID, website, name, source = 'Auto');

      // check the last character for a backslash. do it with and without
      if (website[website.length - 1] === '/') {
        const temp = website.slice(0, -1);
        this.onSaveMd5(placeID, temp, name, source = 'Auto');
      }

      // check the last character for a backslash. do it with and without
      if (website[website.length - 1] !== '/') {
        const temp = website + '/';
        this.onSaveMd5(placeID, temp, name, source = 'Auto');
      }

      cases.forEach(c => {
        if (website.endsWith(c.find)) {
          const temp = website.replace(c.find, c.replace);
          this.onSaveMd5(placeID, temp, name, source = 'Auto');
        }
      });

    }
  }


  ngOnDestroy() {
    if (this.$sub1) {
      this.$sub1.unsubscribe();
    }
  }

}
